{
  "invoice": {
    "title": "Invoices",
    "subtitle": "Cross-merchant invoice list",
    "columns": {
      "number": "Number",
      "merchant": "Merchant",
      "issuedAt": "Issued",
      "dueAt": "Due",
      "amount": "Amount",
      "status": "Status",
      "actions": "Actions"
    },
    "actions": {
      "view": "View",
      "download": "Download PDF",
      "resendEmail": "Resend Email",
      "bulkResend": "Bulk Resend Email",
      "markPaid": "Mark Paid",
      "creditNote": "Issue Credit Note",
      "debitNote": "Issue Debit Note",
      "reversePayment": "Reverse Payment",
      "manualGenerate": "Manually Generate"
    },
    "status": {
      "draft": "Draft",
      "issued": "Issued",
      "partiallyPaid": "Partially Paid",
      "paid": "Paid",
      "overdue": "Overdue",
      "cancelled": "Cancelled"
    },
    "filters": {
      "merchant": "Merchant",
      "status": "Status",
      "periodFrom": "Period From",
      "periodTo": "Period To",
      "overdueOnly": "Overdue Only",
      "search": "Search by invoice number",
      "searchLabel": "Search",
      "searchPlaceholder": "Search by invoice ID, merchant…",
      "searchAria": "Search invoices",
      "statusAria": "Status filter",
      "allStatuses": "All statuses",
      "merchantPlaceholder": "All merchants",
      "periodFromAria": "Period start",
      "periodToAria": "Period end",
      "overdueChipAria": "{{count}} overdue invoices",
      "clearFilters": "Clear filters"
    },
    "empty": {
      "title": "No invoices found",
      "body": "Adjust your filters or wait for the next billing cycle."
    },
    "errors": {
      "loadFailed": "Failed to load invoices",
      "resendFailed": "Failed to resend invoice email",
      "amountMismatch": "Payment amount does not match invoice total"
    },
    "confirm": {
      "bulkResend": "Resend email for {{count}} invoice(s)?",
      "markPaid": "Confirm this invoice has been paid in full?",
      "reverse": "Reverse the payment? This action is logged in audit."
    },
    "detail": {
      "paymentHistory": "Payment History",
      "versions": "Version History",
      "linkedDocs": "Linked Documents",
      "downloadPdf": "Download PDF",
      "statusLabels": {
        "DRAFT": "Draft",
        "SENT": "Sent · Awaiting Payment",
        "PARTIAL": "Partial",
        "PAID": "Paid",
        "OVERDUE": "Overdue",
        "VOID": "Void",
        "PENDING_APPROVAL": "Pending Approval"
      },
      "missingId": "Missing invoice id.",
      "backToInvoices": "Back to Invoices",
      "heading": "Invoice {{number}}",
      "merchantPrefix": "Merchant:",
      "cyclePrefix": "Cycle:",
      "createdPrefix": "Created",
      "loading": "Loading…",
      "unavailable": "Detail unavailable.",
      "resendDraftTooltip": "Cannot resend a DRAFT invoice — generate first",
      "cnDraftTooltip": "Invoice must be SENT or beyond before issuing a credit note",
      "dnNotImplementedTitle": "Debit Note not available yet",
      "dnNotImplementedDesc": "The backend endpoint /admin/invoices/:id/debit-notes is not available yet. Please use a Credit Note or contact an admin.",
      "dnNotImplementedTooltip": "Debit Note: backend endpoint not available yet",
      "markPaidDraftTooltip": "Invoice must be SENT or beyond before marking paid",
      "lineItems": "Line items",
      "lineItemsCols": {
        "order": "Order #",
        "chargeType": "Charge Type",
        "net": "Net",
        "taxRate": "Tax Rate",
        "tax": "Tax",
        "gross": "Gross"
      },
      "noLineItems": "No line items.",
      "taxLinesTitle": "Tax lines (by jurisdiction)",
      "taxable": "taxable",
      "taxWord": "tax",
      "reverseCharge": "reverse-charge",
      "subtotal": "Subtotal",
      "creditApplied": "Credit applied",
      "taxLabel": "Tax",
      "totalDue": "Total Due",
      "status": "Status",
      "duePrefix": "Due:",
      "netTermsPrefix": "Net terms:",
      "remainingPrefix": "Remaining:",
      "timeline": "Timeline",
      "timelineLabels": {
        "created": "Created",
        "sent": "Sent",
        "paid": "Paid"
      },
      "timelineBy": {
        "system": "system",
        "admin": "admin",
        "pending": "pending"
      },
      "auditMetadata": "Audit metadata",
      "auditFields": {
        "invoiceId": "Invoice ID",
        "merchantId": "Merchant ID",
        "version": "Version",
        "created": "Created",
        "updated": "Updated"
      },
      "chargeTypeLabels": {
        "ORDER_CHARGE": "Order",
        "SURCHARGE_CHARGE": "Surcharge",
        "EMBROIDERY_CHARGE": "Embroidery"
      },
      "reverseConfirm": "Reverse payment {{reference}} for {{amount}}?",
      "markPaidModal": {
        "title": "Mark Paid",
        "amountLabel": "Amount (USD)",
        "amountPositive": "Amount must be > 0",
        "referenceRequired": "Reference required",
        "remaining": "Remaining: {{amount}}",
        "gatewayLabel": "Gateway",
        "referenceLabel": "Reference",
        "referencePlaceholder": "e.g. SWIFT-DBS-2026-04-29-001",
        "proofLabel": "Proof file URL (optional)",
        "proofPlaceholder": "https://…/proof.pdf",
        "notesLabel": "Notes (optional)",
        "overThresholdNotice": "Admin approval required — amount exceeds the $10,000 accountant threshold.",
        "cancel": "Cancel",
        "submitting": "Submitting…",
        "submit": "Submit",
        "adminApprovalTitle": "Admin approval required",
        "adminApprovalDesc": "Amount exceeds $10,000 — only admin role can mark this paid.",
        "adminApprovalTooltip": "Admin approval required"
      },
      "toast": {
        "loadFailed": "Failed to load invoice",
        "markPaidFailed": "Mark paid failed",
        "paymentRecorded": "Payment recorded",
        "paymentRecordedDesc": "Awaiting approval. Approve from the payment history list.",
        "approveFailed": "Approve failed",
        "paymentApproved": "Payment approved",
        "paymentApprovedDesc": "Invoice status updated to PAID/PARTIAL.",
        "rejectReasonRequired": "Reject reason required",
        "rejectReasonMin": "Minimum 3 characters.",
        "rejectFailed": "Reject failed",
        "paymentRejected": "Payment rejected",
        "paymentRejectedDesc": "Merchant has been notified with the reason.",
        "reverseFailed": "Reverse failed",
        "paymentReversed": "Payment reversed",
        "paymentReversedDesc": "Invoice balance restored; ledger entry inverted.",
        "resendFailed": "Resend failed",
        "emailQueued": "Email queued",
        "emailQueuedDesc": "Invoice email re-sent to merchant billing contact.",
        "networkError": "Network error - check connection",
        "unknown": "Unknown"
      },
      "approveModal": {
        "title": "Review submitted payment",
        "amount": "Amount",
        "gateway": "Gateway",
        "reference": "Reference",
        "submitted": "Submitted",
        "notesPrefix": "Notes:",
        "proofAttachment": "Proof attachment",
        "proofAlt": "Payment proof",
        "proofPdfTitle": "Payment proof PDF",
        "openProof": "Open proof file ↗",
        "noProof": "No proof file attached.",
        "rejectReasonLabel": "Reject reason",
        "rejectReasonPlaceholder": "Min 3 chars — sent to merchant in email",
        "reject": "Reject",
        "confirmReject": "Confirm reject",
        "rejecting": "Rejecting…",
        "approve": "Approve",
        "approving": "Approving…"
      }
    },
    "list": {
      "subtitle": "Manage merchant invoices across the platform. Invoices are immutable — issue a credit or debit note instead of editing.",
      "generateManual": "+ Generate Manual",
      "columns": {
        "invoiceNumber": "Invoice #",
        "type": "Type",
        "merchant": "Merchant",
        "period": "Period",
        "amount": "Amount",
        "paymentGateway": "Payment Gateway",
        "gatewayFee": "Gateway fee",
        "status": "Status",
        "due": "Due",
        "actions": "Actions"
      },
      "selectAllAria": "Select all on page",
      "selectRowAria": "Select invoice {{number}}",
      "loading": "Loading invoices…",
      "emptyFiltered": "No invoices match the current filters",
      "bulk": {
        "selected": "{{count}} invoices selected",
        "eligibleNote": "({{count}} eligible to resend — DRAFT / VOID excluded)",
        "resend": "Resend Email ({{count}})",
        "sending": "Sending…",
        "clear": "Clear",
        "noPermission": "You don't have permission to resend invoice emails.",
        "selectEligible": "Select at least one SENT / PARTIAL / OVERDUE / PAID invoice"
      },
      "toast": {
        "oneQueued": "1 email queued",
        "manyQueued": "{{count}} emails queued",
        "queuedDesc": "Invoice resend requests sent successfully.",
        "partialQueued": "{{queued}} of {{total}} emails queued",
        "partialDesc": "{{count}} skipped ({{reason}}).",
        "skippedTitle": "Resend skipped",
        "skippedDescFallback": "No emails queued.",
        "resendFailed": "Resend failed"
      },
      "prefixTooltip": "Numbering prefix: {{prefix}}"
    },
    "typeLabels": {
      "Payment": "Payment",
      "Refund": "Refund",
      "Surcharge": "Surcharge"
    },
    "statusLabels": {
      "DRAFT": "Draft",
      "SENT": "Sent",
      "PARTIAL": "Partial",
      "PAID": "Paid",
      "OVERDUE": "Overdue",
      "VOID": "Void"
    },
    "paymentStatusLabels": {
      "PENDING_APPROVAL": "Pending approval",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "REVERSED": "Reversed"
    },
    "pdfPreview": {
      "unavailable": "PDF preview unavailable.",
      "draftHint": "DRAFT invoices render PDF only after status transitions to SENT.",
      "label": "Invoice PDF preview",
      "openNewTab": "Open in new tab ↗",
      "iframeTitle": "Invoice {{number}} PDF preview"
    },
    "paymentHistory": {
      "loading": "Loading payment history…",
      "empty": "No payments recorded yet.",
      "reversedBadge": "Reversed",
      "refPrefix": "Ref:",
      "submittedPrefix": "Submitted:",
      "approvedPrefix": "Approved:",
      "reversedPrefix": "Reversed:",
      "rejectedPrefix": "Rejected:",
      "reverseReasonPrefix": "Reverse reason:",
      "review": "Review",
      "reverse": "Reverse"
    },
    "markPaidModal": {
      "aria": "Mark Paid — Invoice {{number}}",
      "title": "Mark Paid — Invoice {{number}}",
      "subtitle": "Record a payment for this invoice. The action is saved to the audit log.",
      "outstanding": "Outstanding",
      "version": "Version",
      "amountLabel": "Amount (USD)",
      "amountHelp": "Defaults to the outstanding balance. Enter a lower value for a partial payment (status becomes PARTIAL).",
      "amountPositive": "Amount must be greater than 0.",
      "gatewayLabel": "Payment gateway",
      "referenceLabel": "Reference",
      "referencePlaceholder": "e.g. WIRE-20260517-1234",
      "referenceHelp": "Required — wire/SWIFT/transaction id for later reconciliation.",
      "referenceMin": "Reference required (minimum {{min}} characters).",
      "referenceMax": "Reference too long (maximum {{max}} characters).",
      "notesLabel": "Notes (optional)",
      "notesPlaceholder": "e.g. Confirmed on the bank portal.",
      "thresholdBlock": "Amount exceeds the accountant's $10,000 limit. The invoice:mark_paid:unlimited permission (Admin/Super Admin) is required — ask an admin to approve or lower the amount.",
      "thresholdTooltip": "Amount exceeds $10,000 — invoice:mark_paid:unlimited permission (Admin) required.",
      "thresholdWarnTitle": "Admin permission required to approve this amount",
      "thresholdWarnDesc": "Amount exceeds $10,000 — invoice:mark_paid:unlimited permission (Admin/Super Admin) required.",
      "cancel": "Cancel",
      "submitting": "Processing…",
      "submit": "Mark Paid",
      "toast": {
        "success": "Invoice marked as Paid",
        "successDesc": "Invoice {{number}} payment status updated.",
        "conflictTitle": "Invoice was updated by someone else",
        "conflictDesc": "Invoice was updated by another user — refresh and try again.",
        "thresholdError": "Amount exceeds the allowed limit — invoice:mark_paid:unlimited permission required.",
        "voidTitle": "Invoice is VOID",
        "voidDesc": "Invoice is VOID — it cannot be paid.",
        "failTitle": "Could not mark as Paid",
        "networkTitle": "Network error",
        "networkDesc": "Check your connection and try again."
      }
    },
    "reverseModal": {
      "aria": "Reverse payment",
      "title": "Reverse payment",
      "subtitle": "This reverses the payment, recalculates the invoice status and writes an audit log. Use only for a bank bounce or data-entry error.",
      "amount": "Amount",
      "gateway": "Gateway",
      "reference": "Reference",
      "createdAt": "Created",
      "approvedBy": "Approved by",
      "submittedBy": "Submitted by",
      "reasonLabel": "Reverse reason",
      "reasonPlaceholder": "e.g. Bank notified the wire was returned due to an incorrect SWIFT BIC code — reverse and request resubmission.",
      "reasonMin": "Reverse reason needs at least {{min}} characters (currently {{count}}).",
      "reasonMax": "Reverse reason can be at most {{max}} characters.",
      "reasonRemaining": "{{count}} more characters needed.",
      "reasonCount": "{{count}}/{{max}}",
      "cancel": "Cancel",
      "submitting": "Reversing…",
      "submit": "Reverse payment",
      "toast": {
        "success": "Payment reversed",
        "successDesc": "Payment {{reference}} has been reversed. The invoice status will recalculate automatically.",
        "forbiddenTitle": "No permission to reverse",
        "forbiddenDesc": "You need the invoice:payment_reverse permission to perform this action.",
        "notFoundTitle": "Payment not found",
        "notFoundDesc": "The payment was deleted or changed — the list will refresh.",
        "alreadyTitle": "Payment already reversed",
        "alreadyDesc": "Someone else already reversed this payment — the list will refresh.",
        "reasonTooShort": "Reverse reason needs at least {{min}} characters.",
        "failTitle": "Reverse failed",
        "failDesc": "Please try again.",
        "networkTitle": "Network error",
        "networkDesc": "Check your connection and try again."
      }
    },
    "creditNoteModal": {
      "aria": "Issue Credit Note",
      "title": "Issue Credit Note",
      "subtitle": "Create CN-YYYYMM-XXXXX linked to invoice{{label}}. The backend generates the PDF and audit log.",
      "lineItemsLabel": "Line items (select related lines — optional)",
      "noLineItems": "Invoice line items not loaded. The credit note will apply to the whole invoice if no line is selected.",
      "selectedSummary": "Selected {{selected}}/{{total}} lines · {{amount}}",
      "amountInvalid": "Enter a valid amount (greater than 0).",
      "reasonMin": "Reason needs at least {{min}} characters.",
      "amountExceeds": "Credit note amount exceeds the invoice total. Enter an amount less than or equal to the invoice total.",
      "cancel": "Cancel",
      "submitting": "Issuing…",
      "submit": "Issue Credit Note",
      "toast": {
        "success": "Credit Note {{number}} issued",
        "successDesc": "{{amount}} has been recorded. PDF and audit log created.",
        "invalidTitle": "Invalid data",
        "notFoundTitle": "Invoice not found",
        "failTitle": "Could not issue Credit Note",
        "networkTitle": "Network error",
        "networkDesc": "Could not reach the server. Check your connection and try again."
      }
    },
    "debitNoteModal": {
      "aria": "Issue Debit Note",
      "title": "Issue Debit Note",
      "subtitle": "Create DN-YYYYMM-XXXXX linked to invoice{{label}}. The backend generates the PDF and audit log.",
      "descLabel": "Debit line description",
      "descPlaceholder": "e.g. \"Rush delivery surcharge for OR\". At least {{min}} characters.",
      "descHint": "{{count}}/{{max}} characters (minimum {{min}}).",
      "descError": "The debit line description must be {{min}}-{{max}} characters.",
      "referenceLineItems": "Original invoice line items (reference only)",
      "amountInvalid": "Enter a valid amount (greater than 0).",
      "reasonMin": "Reason needs at least {{min}} characters.",
      "cancel": "Cancel",
      "submitting": "Issuing…",
      "submit": "Issue Debit Note",
      "toast": {
        "success": "Debit Note {{number}} issued",
        "successDesc": "{{amount}} has been recorded. PDF and audit log created.",
        "invalidTitle": "Invalid data",
        "notFoundTitle": "Invoice not found",
        "failTitle": "Could not issue Debit Note",
        "networkTitle": "Network error",
        "networkDesc": "Could not reach the server. Check your connection and try again."
      }
    },
    "noteForm": {
      "amountLabel": "Amount (USD)",
      "amountPlaceholder": "0.00",
      "amountHint": "Amounts are in USD. Enter dollars; the system stores cents.",
      "invoiceTotal": "Invoice total: {{amount}}",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "At least 10 characters — explain in detail (saved to the audit log for compliance).",
      "reasonRemaining": "{{count}} more characters needed (minimum {{min}}).",
      "reasonCount": "{{count}}/{{max}} characters"
    }
  },
  "credit_memo": {
    "title": "Credit Memos",
    "subtitle": "Issued credit memos across merchants",
    "columns": {
      "number": "Memo #",
      "merchant": "Merchant",
      "issuedAt": "Issued",
      "amount": "Amount",
      "balance": "Remaining Balance",
      "status": "Status",
      "reason": "Reason",
      "appliedTo": "Applied to",
      "actions": "Actions",
      "issuedBy": "Issued by",
      "notes": "Notes"
    },
    "actions": {
      "issue": "Issue Credit Memo",
      "apply": "Apply to Invoice",
      "void": "Void",
      "approving": "Approving…",
      "applyShort": "Apply",
      "applyTooltip": "Apply this credit to an invoice",
      "cancel": "Cancel"
    },
    "status": {
      "draft": "Draft",
      "issued": "Issued",
      "partiallyApplied": "Partially Applied",
      "fullyApplied": "Fully Applied",
      "voided": "Voided"
    },
    "empty": {
      "title": "No credit memos",
      "body": "Issue a credit memo from the invoice detail page.",
      "none": "No credit memos found",
      "filtered": "No credit memos match the current filters"
    },
    "approvals": {
      "title": "Pending Approvals",
      "approve": "Approve",
      "reject": "Reject",
      "requestChanges": "Request Changes"
    },
    "filters": {
      "allStatuses": "All statuses",
      "searchLabel": "Search",
      "searchPlaceholder": "Search credit memo #…",
      "searchAria": "Search credit memos",
      "statusAria": "Status filter",
      "allMerchants": "All merchants",
      "clear": "Clear filters"
    },
    "filterOptions": {
      "active": "Active",
      "applied": "Applied",
      "partiallyApplied": "Partially applied",
      "converted": "Converted",
      "refundedToBank": "Refunded to bank",
      "pendingApproval": "Pending approval",
      "rejected": "Rejected"
    },
    "reason": {
      "goodwill": "Goodwill",
      "refund": "Refund",
      "overpayment": "Overpayment",
      "negotiated": "Negotiated"
    },
    "badge": {
      "active": "Active",
      "pending": "Pending",
      "applied": "Applied",
      "partial": "Partial",
      "converted": "Converted",
      "refunded": "Refunded",
      "rejected": "Rejected",
      "dormant": "Dormant",
      "voided": "Voided"
    },
    "stale": {
      "tooltip": "Inactive for 12+ months — review for void or apply",
      "ariaLabel": "Stale credit memo (12+ months inactive)",
      "label": "Stale"
    },
    "list": {
      "subtitle": "Issue credits, apply to invoices, void if needed",
      "pendingApprovalLink": "Pending approval",
      "pendingApprovalLinkTooltip": "Open the pending-approval queue",
      "loading": "Loading credit memos…"
    },
    "toast": {
      "loadFailed": "Failed to load credit memos",
      "networkError": "Network error",
      "networkErrorDesc": "Network error - check connection",
      "adminRequired": "Admin role required",
      "adminRequiredDesc": "Only the admin role can approve memos pending approval.",
      "approveFailed": "Approve failed",
      "approved": "Credit memo approved",
      "approvedDesc": "The credit memo is now active.",
      "genericError": "Something went wrong"
    },
    "approvalsPage": {
      "title": "Pending Approval Queue",
      "subtitle": "Credit memos awaiting approval — accountant-issued memos above $500 need admin confirmation before becoming active.",
      "readonlyPrefix": "You don't have the",
      "readonlySuffix": "permission — you can only view the list. The Approve/Reject buttons stay hidden until you're granted admin access.",
      "issuedByFilterLabel": "Issued by (accountant)",
      "allAccountants": "All accountants",
      "amountMin": "Amount min (USD)",
      "amountMax": "Amount max (USD)",
      "loading": "Loading pending approvals…",
      "emptyFiltered": "No pending approvals match the current filters",
      "emptyNone": "No credit memos awaiting approval",
      "overThresholdTooltip": "Over $500 — admin approval required",
      "loadFailed": "Failed to load pending approvals"
    },
    "apply": {
      "title": "Apply credit memo · {{id}}",
      "merchantLabel": "Merchant:",
      "remainingLabel": "Remaining:",
      "invoiceLabel": "Invoice (oldest first)",
      "loadingInvoices": "Loading invoices…",
      "noInvoicesPrefix": "No ISSUED/PARTIAL/OVERDUE invoice for this merchant. Create an invoice via",
      "noInvoicesSuffix": "first, or wait for the invoice cron cycle.",
      "selectInvoicePlaceholder": "— Select invoice —",
      "outstanding": "outstanding",
      "amountLabel": "Amount (USD)",
      "amountPlaceholder": "e.g. 25.00",
      "maxHint": "Max: {{max}} = min(memo remaining {{remaining}}, invoice outstanding {{outstanding}})",
      "amountTooHigh": "Amount exceeds the limit — max {{max}}.",
      "submitting": "Applying…",
      "errSelectInvoice": "Please select an invoice",
      "errAmountPositive": "Amount must be a positive number (USD)",
      "errAmountTooHigh": "Amount exceeds the limit — max {{max}} (min of remaining and invoice due)",
      "errInvoiceNotFound": "Invoice {{id}} not found",
      "errMissingVersion": "Invoice response missing version field — unexpected shape",
      "errMerchantMismatch": "Invoice belongs to a different merchant than the credit memo",
      "toastPaidTitle": "Credit applied — invoice PAID",
      "toastAppliedTitle": "Credit memo applied",
      "toastPaidDesc": "Invoice {{invoice}} has been paid in full for {{amount}}.",
      "toastAppliedDesc": "Applied {{amount}} to invoice {{invoice}}."
    },
    "issue": {
      "merchantPlaceholder": "Select INVOICE merchant…",
      "merchantHint": "Only INVOICE-mode merchants are eligible for credit memos.",
      "thresholdTitle": "Pending approval required.",
      "thresholdBefore": "Amount exceeds $500 — accountant-issued memos above this threshold are routed to the",
      "thresholdQueueLink": "pending-approval queue",
      "thresholdAfter": ". An admin must approve before the credit becomes active.",
      "notesPlaceholder": "Reason for goodwill credit (3–1000 chars)…",
      "issueTypeLabel": "Issue type:",
      "issueTypeHint": "(other types are issued automatically by the refund/overpayment workers).",
      "submitTitleThreshold": "Will be routed to the pending-approval queue",
      "submitting": "Issuing…",
      "submitForApproval": "Submit for approval",
      "submitDefault": "Issue credit memo",
      "errMerchantRequired": "Merchant required",
      "errAmountPositive": "Amount must be > 0",
      "errNotesMin": "Notes must be at least 3 characters",
      "toastFailed": "Issue credit memo failed",
      "toastPendingTitle": "Credit memo pending admin approval",
      "toastIssuedTitle": "Credit memo issued",
      "toastPendingDesc": "Amount exceeds $500 — routed to the pending-approval queue.",
      "toastIssuedDesc": "The credit memo is now active and can be applied to invoices."
    },
    "actionsCell": {
      "approveTooltip": "Approve credit memo (status → Active)",
      "rejectTooltip": "Reject credit memo (status → Rejected)",
      "rejectModalTitle": "Reject credit memo",
      "memoLabel": "Memo:",
      "amountLabel": "Amount:",
      "reasonLabel": "Rejection reason",
      "reasonPlaceholder": "Explain why you're rejecting (at least {{min}} characters)…",
      "charCount": "{{count}} / {{max}} characters (minimum {{min}})",
      "rejectNotice": "After you confirm, the issuing accountant will receive an email with the rejection reason. An audit log entry is created automatically.",
      "rejecting": "Rejecting…",
      "rejectSubmit": "Reject credit memo",
      "noApprovePerm": "You don't have permission to approve credit memos.",
      "reasonRequired": "Reason is required — minimum {{min}} characters, maximum {{max}} characters.",
      "alreadyResolvedTitle": "Credit memo already resolved",
      "alreadyResolvedDesc": "Another admin just approved/rejected it. Refreshing…",
      "rejectFailed": "Reject failed",
      "rejectedTitle": "Credit memo rejected",
      "rejectedDesc": "Credit memo rejected; the accountant has been notified."
    }
  },
  "refund_task": {
    "title": "Refund Tasks",
    "subtitle": "4-eyes refund approval queue",
    "columns": {
      "id": "Task ID",
      "merchant": "Merchant",
      "amount": "Amount",
      "reason": "Reason",
      "requester": "Requested By",
      "approver": "Approver",
      "status": "Status"
    },
    "status": {
      "pendingApproval": "Pending Approval",
      "approved": "Approved",
      "rejected": "Rejected",
      "processed": "Processed",
      "failed": "Failed"
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject",
      "process": "Process Refund"
    },
    "errors": {
      "selfApproval": "You cannot approve your own refund request",
      "alreadyProcessed": "This refund has already been processed",
      "generic": "Something went wrong"
    },
    "relative": {
      "justNow": "just now",
      "minutes": "{{count}}m ago",
      "hours": "{{count}}h ago",
      "days": "{{count}}d ago"
    },
    "toast": {
      "networkError": "Network error",
      "networkErrorDescription": "Network error - check connection"
    },
    "filter": {
      "merchantLabel": "Merchant filter",
      "merchantAria": "Merchant ID filter",
      "merchantPlaceholder": "Merchant id…",
      "clear": "Clear"
    },
    "queue": {
      "title": "Refund Task Queue",
      "subtitle": "Manual bank-transfer refunds — segregation of duties enforced (4-eyes).",
      "tab": {
        "pendingBankTransfer": "Pending bank transfer",
        "completed": "Completed"
      },
      "column": {
        "taskNumber": "Task #",
        "merchant": "Merchant",
        "amount": "Amount",
        "bankAccount": "Bank account",
        "createdBy": "Created by",
        "completed": "Completed",
        "created": "Created",
        "action": "Action"
      },
      "loading": "Loading refund tasks…",
      "empty": "No refund tasks in this queue",
      "sameUserTitle": "Same as current user (4-eyes block)",
      "youBadge": "you",
      "completeBlockedTitle": "Cannot complete refund task you created (4-eyes principle). Another accountant or admin must complete.",
      "completeTitle": "Mark refund completed",
      "complete": "Complete",
      "refPrefix": "Ref: {{ref}}",
      "loadFailed": "Failed to load refund tasks"
    },
    "complete": {
      "proofInvalidFormat": "Invalid format. Only PDF, JPG or PNG are accepted.",
      "proofTooLarge": "File exceeds the 5MB limit (currently {{size}}MB).",
      "bankRefMin": "Bank reference is required (min {{min}} chars)",
      "bankRefMax": "Bank reference too long (max {{max}} chars)",
      "overrideReasonMin": "Override reason is required (min {{min}} chars)",
      "overrideReasonMax": "Override reason too long (max {{max}} chars)",
      "sameUserAdmin": "Same user as creator — toggle admin override + reason (4-eyes)",
      "sameUserNonAdmin": "A different accountant is required (4-eyes)",
      "proofUploadFailed": "Proof upload failed. You can remove the attachment and retry, or contact ops.",
      "toastFailed": "Complete refund failed",
      "toastStaleTitle": "Refund task no longer available",
      "toastStaleDesc": "This request was already completed or removed. The queue has been refreshed.",
      "toastSuccess": "Refund completed",
      "toastSuccessDesc": "Task {{taskNumber}} marked completed",
      "networkError": "Network error",
      "networkErrorDesc": "Network error - check connection",
      "title": "Complete refund {{taskNumber}}",
      "summaryMerchant": "Merchant:",
      "summaryAmount": "Amount:",
      "summaryBankAccount": "Bank account:",
      "summaryCreatedBy": "Created by:",
      "bannerTitle": "Cannot complete refund task you created (4-eyes principle).",
      "bannerAdmin": "Another accountant or admin must complete. As an admin, you may override below with a written reason — the override is audited.",
      "bannerNonAdmin": "Another accountant or admin must complete. Ask another accountant (or an admin with override + reason) to complete this task.",
      "bankRefLabel": "Bank reference",
      "bankRefPlaceholder": "e.g. WIRE-20260517-9988",
      "bankRefHelp": "Required — wire / SWIFT confirmation after bank transfer (audited).",
      "notesLabel": "Notes (optional)",
      "notesPlaceholder": "Internal notes — wire confirmation, comms, etc.",
      "proofLabel": "Bank statement (optional)",
      "proofRemove": "Remove",
      "proofHelp": "PDF / JPG / PNG, max 5MB. Stored on dedicated file server.",
      "overrideCheckbox": "Admin override (segregation of duties)",
      "overrideReasonLabel": "Override reason",
      "overrideReasonPlaceholder": "Why are you overriding 4-eyes? (audited as override_segregation)",
      "overrideReasonHelp": "Min {{min}} chars. Written to audit_log with entity_type=override_segregation.",
      "cancel": "Cancel",
      "submitting": "Completing…",
      "submit": "Complete refund"
    }
  },
  "payment_request": {
    "title": "Pre-payment Requests",
    "subtitle": "Manual payment requests pending review",
    "columns": {
      "number": "PR Number",
      "merchant": "Merchant",
      "amount": "Amount",
      "requestedAt": "Requested",
      "status": "Status",
      "date": "Date",
      "legalEntity": "Legal Entity",
      "createdBy": "Created By"
    },
    "status": {
      "pending": "Pending",
      "approved": "Approved",
      "paid": "Paid",
      "rejected": "Rejected",
      "expired": "Expired"
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject",
      "markPaid": "Mark Paid",
      "create": "New Payment Request"
    },
    "page": {
      "description": "PDF documents sent to merchants to support wire-transfer onboarding. A PR creates no cash flow and cannot be edited after creation."
    },
    "toast": {
      "created": "Payment Request created",
      "createdDesc": "PR {{prNumber}} now appears at the top of the list."
    },
    "loading": "Loading…",
    "empty": "No Payment Requests yet.",
    "networkError": "Network error - check connection",
    "noPerm": "You don't have permission to create PRs.",
    "noPermTitle": "You need permission to create a Payment Request.",
    "filters": {
      "search": "Merchant name / PR number",
      "searchPlaceholder": "Search merchant or PR-YYYYMM-XXXXX",
      "from": "From",
      "to": "To",
      "searchBtn": "Search"
    },
    "fields": {
      "name": "Name",
      "phone": "Phone",
      "email": "Email",
      "business_name": "Business Name",
      "tax_id": "Tax ID",
      "business_address": "Business Address",
      "zip_code": "Zip Code"
    },
    "form": {
      "merchantRequired": "Please select a merchant.",
      "legalEntityRequired": "Please select a Legal Entity.",
      "amountPositive": "Amount must be a positive number (USD).",
      "descriptionRequired": "Description is required.",
      "descriptionMax": "Description max {{max}} characters.",
      "createSuccess": "Payment Request created successfully",
      "createSuccessDesc": "Created PR {{prNumber}} for the merchant.",
      "createSuccessFallback": "New PR created.",
      "title": "Create Payment Request",
      "merchantInfoLegend": "Merchant Info on PDF",
      "loadingMerchant": "Loading merchant info…",
      "empty": "(empty)",
      "toggleHint": "Toggle ON + empty value → the line is skipped on the PDF.",
      "loadingShort": "Loading…",
      "noLegalEntities": "No Legal Entities yet",
      "selectLegalEntity": "Select Legal Entity",
      "defaultSuffix": " (default)",
      "bankAccount": "Bank Account",
      "selectLegalEntityFirst": "Select a Legal Entity first",
      "selectBankAccount": "Select Bank Account",
      "primarySuffix": " · primary",
      "amount": "Amount (USD)",
      "description": "Description",
      "descriptionHelp": "{{count}}/{{max}} chars · auto-filled to \"{{default}}\", editable by admin.",
      "cancel": "Cancel",
      "creating": "Creating…",
      "submit": "Create PR"
    },
    "pdf": {
      "title": "Payment Request",
      "iframeTitle": "Payment Request {{prNumber}} PDF preview",
      "notReady": "PDF not ready yet.",
      "notReadyHint": "The PDF is rendered asynchronously — try again in ~30 seconds.",
      "close": "Close",
      "download": "Download PDF"
    }
  },
  "legal_entity": {
    "title": "Legal Entities",
    "subtitle": "Billing entities and bank accounts",
    "columns": {
      "name": "Name",
      "taxId": "Tax ID",
      "country": "Country",
      "bankAccount": "Bank Account",
      "isActive": "Active",
      "legalName": "Legal name",
      "taxConfig": "Tax config",
      "timezone": "Timezone",
      "invoices": "Invoices",
      "created": "Created",
      "actions": "Actions"
    },
    "actions": {
      "create": "Add Legal Entity",
      "edit": "Edit",
      "deactivate": "Deactivate",
      "addBankAccount": "Add Bank Account",
      "assignMerchant": "Assign Merchant",
      "delete": "Delete"
    },
    "tabs": {
      "details": "Details",
      "bankAccounts": "Bank Accounts",
      "merchants": "Merchants"
    },
    "fields": {
      "name": "Legal Name",
      "taxId": "Tax ID / VAT Number",
      "country": "Country",
      "address": "Address",
      "currency": "Default Currency",
      "active": "Active"
    },
    "errors": {
      "duplicateTaxId": "A legal entity with this Tax ID already exists",
      "cannotDeactivate": "Cannot deactivate — entity is linked to active merchants",
      "noOtherEntity": "No other entity to apply the logo to."
    },
    "common": {
      "cancel": "Cancel",
      "remove": "Remove",
      "removing": "Removing…",
      "networkTitle": "Network error",
      "networkDesc": "Network error — check connection"
    },
    "page": {
      "subtitle": "Multi-entity registry — invoices/receipts are issued per entity. Each entity keeps its own tax config (VAT / GST / SALES_TAX / NONE) and IANA timezone for the billing cron.",
      "newEntity": "+ New entity",
      "searchPlaceholder": "Search by name or tax ID…",
      "sort": "Sort",
      "sortNewest": "Newest first",
      "sortOldest": "Oldest first",
      "sortName": "Name (A→Z)",
      "loading": "Loading legal entities…",
      "loadError": "Failed to load: {{error}}",
      "retry": "Retry",
      "empty": "No legal entities yet — click \"+ New entity\" to create Printway HK.",
      "defaultBadge": "Default",
      "taxMissingTip": "Migration warning: tax config is not set for this entity.",
      "taxNotConfigured": "Tax not configured",
      "timezoneMissingTip": "Migration warning: timezone is not set — the invoice cron will skip this entity.",
      "timezoneNotSet": "Timezone not set",
      "loadingShort": "Loading…",
      "setDefault": "Set default"
    },
    "toasts": {
      "loadDetailFailed": "Failed to load entity",
      "setDefaultSuccess": "Set as default",
      "setDefaultFailed": "Failed to set default",
      "deleteBlockedTitle": "Cannot delete",
      "deleteSuccess": "Legal entity deleted",
      "deleteFailed": "Failed to delete"
    },
    "logo": {
      "unknownError": "unknown error",
      "syncPartial": "Synced {{done}}/{{total}} entities. Errors: {{errors}}"
    },
    "delete": {
      "inUseDesc": "Invoices/receipts still reference \"{{name}}\" ({{count}} documents). Soft-archive keeps the snapshot on existing documents.",
      "defaultBlockedTitle": "Cannot delete the default entity",
      "defaultBlockedDesc": "Set another entity as default before deleting the current one."
    },
    "setDefaultConfirm": {
      "title": "Set as default legal entity?",
      "desc": "New invoices/receipts issued without a specified entity will use \"{{name}}\". Existing documents keep their snapshot unchanged."
    },
    "deleteConfirm": {
      "title": "Delete legal entity?",
      "desc": "Delete \"{{name}}\" ({{taxId}}). The system blocks deletion if {{count}} invoices/receipts reference it or if it is the default entity."
    },
    "form": {
      "editTitle": "Edit legal entity",
      "createTitle": "New legal entity",
      "editNote": "Note: changes apply only to invoices/receipts issued from now on (snapshot pattern — existing documents keep the entity details captured at issue time).",
      "legacyTimezoneWarning": "Legacy entity — timezone is not set. Set a timezone to enable the invoice billing cron.",
      "codeLabel": "Entity code",
      "codeHelp": "UPPER_SNAKE — used in the invoice / receipt sequence prefix.",
      "countryLabel": "Country (ISO-2)",
      "taxIdLabel": "Tax ID (legal_id)",
      "taxIdHelp": "Must be unique across entities.",
      "nameLabel": "Legal name",
      "addressLabel": "Address",
      "bankInfoLabel": "Bank info",
      "bankInfoPlaceholder": "DBS Bank HK / Account 63000304744 / SWIFT DHBKHKHH",
      "logoLabel": "Logo",
      "logoHelper": "PNG / JPEG / WEBP / SVG ≤ 2 MB. Shown on invoice PDF + payment request PDF.",
      "applying": "Applying…",
      "applyToAll": "Apply to all",
      "timezoneLabel": "Timezone (IANA)",
      "timezoneWarning": "Timezone not set — set a timezone to enable the invoice billing cron.",
      "saving": "Saving…",
      "creating": "Creating…",
      "saveChanges": "Save changes",
      "createEntity": "Create entity",
      "logoMissingTitle": "No logo URL yet",
      "logoMissingDesc": "Enter a logo URL before applying it to other entities.",
      "logoSyncedTitle": "Logo synced",
      "logoSyncedDesc": "The logo has been copied to the other legal entities.",
      "logoSyncFailed": "Failed to sync the logo",
      "logoApplyFailedTitle": "Apply logo failed",
      "duplicateTaxCode": "Tax ID/Code is already used by another entity",
      "preconditionFailed": "The record was edited in another session. Close and reopen to load the latest version.",
      "updateFailed": "Failed to update entity",
      "createFailed": "Failed to create entity",
      "updateSuccess": "Legal entity updated",
      "createSuccess": "Legal entity created"
    },
    "merchants": {
      "pickRequired": "Pick a merchant from the search list.",
      "alreadyAssigned": "This merchant is already assigned to the entity.",
      "alreadyAssignedShort": "Merchant already assigned.",
      "assignFailed": "Failed to assign merchant",
      "reassignedTitle": "Moved merchant to this entity",
      "assignedTitle": "Merchant assigned",
      "reassignedDesc": "The merchant was removed from its previous entity and attached to the current one. Existing document snapshots are unchanged.",
      "notFoundTitle": "Assignment does not exist",
      "removeFailed": "Failed to remove merchant",
      "removedFallbackDesc": "The merchant will use the default entity (id {{id}}…) for new documents. Existing snapshots are unchanged.",
      "removedDesc": "The merchant will use the default entity for new documents.",
      "removedTitle": "Merchant removed from entity",
      "snapshotWarning": "This entity serves {{count}} documents. Merchant assignment changes apply only to documents issued afterwards — existing snapshots are unchanged.",
      "readonly": "You do not have permission to edit the merchants list (requires legal_entity:write).",
      "assignHeading": "Assign merchant",
      "assignSubheading": "Unassigned merchants use the default entity.",
      "searchLabel": "Find merchant",
      "searchPlaceholder": "Search by name, email, or ID",
      "assigning": "Assigning…",
      "addBtn": "Add merchant",
      "empty": "No merchants assigned yet. Every merchant uses the default entity.",
      "col": {
        "merchant": "Merchant",
        "email": "Email",
        "assigned": "Assigned",
        "actions": "Actions"
      }
    },
    "bank": {
      "errGateway": "Required — pick a payment gateway",
      "errRequired": "Required",
      "errSwift": "SWIFT must be 8 or 11 uppercase alphanumeric characters",
      "errPrimaryExists": "This entity already has a primary bank — untick the current primary first, or create a non-primary then change it later.",
      "errSwiftInvalid": "Invalid SWIFT",
      "addFailed": "Failed to add bank account",
      "addedSnapshotTitle": "Bank added — snapshot unchanged",
      "addedSnapshotDesc": "Already-issued invoices/pre-payment requests keep the bank details captured at issue time (snapshot).",
      "addedTitle": "Bank account added",
      "removePrimaryTitle": "Cannot delete the primary bank",
      "removePrimaryDesc": "Set another bank as primary before deleting the current primary bank.",
      "removeBlockedTitle": "Cannot delete bank",
      "removePrimary422": "The primary bank cannot be deleted — set another account as primary first.",
      "removeFailed": "Failed to delete bank account",
      "removedSnapshotTitle": "Bank removed — snapshot kept",
      "removedSnapshotDesc": "Existing documents referencing this bank still show the details captured at issue time.",
      "removedTitle": "Bank account deleted",
      "legend": "Bank accounts",
      "snapshotWarning": "This entity is referenced by {{count}} invoices/PRs. Any bank change affects only documents issued after saving — existing snapshots are unchanged.",
      "readonly": "You do not have permission to edit bank accounts (requires the legal_entity:write permission).",
      "col": {
        "holder": "Account holder · Gateway",
        "number": "Account number",
        "swift": "SWIFT",
        "primary": "Primary",
        "actions": "Actions"
      },
      "empty": "No bank accounts yet. Click \"+ Add bank\" to create the primary bank.",
      "primaryBadge": "Primary",
      "addBankBtn": "+ Add bank",
      "adding": "Adding…",
      "addBankSubmit": "Add bank",
      "gatewayLabel": "Payment gateway",
      "gatewayBankTransfer": "Bank transfer",
      "holderLabel": "Account holder",
      "numberLabel": "Account number",
      "nameLabel": "Bank name",
      "locationLabel": "Bank location",
      "typeLabel": "Account type",
      "swiftLabel": "SWIFT code",
      "swiftPlaceholder": "HSBCHKHHHKH (8 or 11 chars)",
      "swiftHelp": "Leave blank if not applicable. SWIFT must be 8 or 11 alphanumeric characters.",
      "codeLabel": "Bank code",
      "branchLabel": "Branch code",
      "branchPlaceholder": "Branch identifier",
      "addressLabel": "Bank address",
      "setPrimaryLabel": "Set as the primary bank for this entity",
      "primaryHelp": "Only one bank can be ticked as primary per entity. Untick the current primary bank before ticking primary for a new bank.",
      "typePlaceholder": "Checking / Savings / Business",
      "namePlaceholder": "HSBC Hong Kong",
      "locationPlaceholder": "Central, Hong Kong",
      "codePlaceholder": "Routing / ABA / IFSC"
    },
    "tax": {
      "legend": "Tax configuration",
      "noneHint": "Type = NONE — the entity does not issue tax invoices. The fields below are disabled.",
      "requiredHint": "Registration number + standard rate are required for VAT/GST/SALES_TAX.",
      "typeLabel": "Tax type",
      "typeNone": "NONE (no tax)",
      "rateLabel": "Standard rate (%)",
      "ratePlaceholder": "e.g. 10 = 10%",
      "rateHelp": "0–30% (decimal stored as fraction).",
      "regLabel": "Registration number",
      "regPlaceholder": "VAT/GST registration #",
      "jurisdictionLabel": "Jurisdiction (ISO-3166)",
      "jurisdictionAuto": "Auto-suggested from address country: {{country}}.",
      "invoiceLabelLabel": "Invoice tax label",
      "invoiceLabelPlaceholder": "e.g. \"VAT 10%\"",
      "reverseChargeLabel": "Reverse-charge eligible",
      "reverseChargeHint": "(default ON for EU B2B)",
      "jurisdictions": {
        "HK": "HK — Hong Kong",
        "VN": "VN — Vietnam",
        "SG": "SG — Singapore",
        "CN": "CN — China",
        "JP": "JP — Japan",
        "KR": "KR — South Korea",
        "TH": "TH — Thailand",
        "MY": "MY — Malaysia",
        "PH": "PH — Philippines",
        "ID": "ID — Indonesia",
        "IN": "IN — India",
        "AE": "AE — UAE",
        "AU": "AU — Australia",
        "NZ": "NZ — New Zealand",
        "GB": "GB — United Kingdom",
        "DE": "DE — Germany",
        "FR": "FR — France",
        "NL": "NL — Netherlands",
        "IT": "IT — Italy",
        "ES": "ES — Spain",
        "IE": "IE — Ireland",
        "US": "US — United States",
        "US-CA": "US-CA — California",
        "US-NY": "US-NY — New York",
        "US-TX": "US-TX — Texas",
        "US-WA": "US-WA — Washington",
        "CA": "CA — Canada"
      }
    },
    "timezone": {
      "searchPlaceholder": "Search timezone (e.g. Asia/Hong_Kong, hong, new york)…",
      "noMatch": "No timezone matches \"{{query}}\".",
      "helper": "The invoice cron will run cycles in this timezone."
    }
  },
  "aging_report": {
    "title": "Aging Report",
    "subtitle": "Gross + Net + DSO analysis",
    "buckets": {
      "current": "Current",
      "1to30": "1-30 days",
      "31to60": "31-60 days",
      "61to90": "61-90 days",
      "over90": "Over 90 days"
    },
    "metrics": {
      "gross": "Gross AR",
      "net": "Net AR",
      "dso": "DSO (Days Sales Outstanding)"
    },
    "filters": {
      "asOfDate": "As of Date",
      "merchant": "Merchant",
      "merchantPlaceholder": "Select merchant…"
    },
    "actions": {
      "export": "Export CSV",
      "refresh": "Refresh"
    },
    "page": {
      "description": "Outstanding receivables grouped by age (Gross vs Net)"
    },
    "bucketLabels": {
      "0-7d": "0-7 DAYS",
      "8-30d": "8-30 DAYS",
      "30d+": "30+ DAYS"
    },
    "tooltips": {
      "grossNet": "Gross = unpaid invoices + uninvoiced charges. Net = Gross - active credit memos (Printway owes merchant).",
      "dso": "DSO = average days from invoice issue to payment. Lower is better."
    },
    "toast": {
      "loadFailed": "Failed to load aging report",
      "networkError": "Network error - check connection",
      "unexpectedShape": "Unexpected response shape from server.",
      "unknownError": "Unknown error"
    },
    "tiles": {
      "dso": "DSO (DAYS)",
      "dsoSub": "Days Sales Outstanding",
      "totalGross": "TOTAL GROSS",
      "totalNet": "TOTAL NET",
      "netSub": "After active credit memos",
      "invoicesCount": "{{count}} invoices"
    },
    "byMerchant": {
      "title": "By Merchant",
      "hint": "Click a bucket cell to drill into the matching invoices.",
      "colDso": "DSO",
      "colGross": "Gross Outstanding",
      "colNet": "Net Outstanding",
      "overall": "Overall"
    },
    "loading": "Loading aging report…",
    "loadingShort": "Loading…",
    "empty": {
      "title": "No outstanding receivables",
      "body": "Every invoice has been paid or there are no INVOICE-mode merchants yet. Aging buckets will appear here once invoices age past due."
    }
  },
  "transfer_group": {
    "title": "Transfer Groups",
    "subtitle": "Merchant transfer groups for payouts",
    "columns": {
      "name": "Group Name",
      "memberCount": "Members",
      "createdAt": "Created",
      "isActive": "Active",
      "description": "Description",
      "owner": "Owner",
      "perMemberLimit": "Per-member limit",
      "status": "Status",
      "actions": "Actions"
    },
    "actions": {
      "create": "Create Group",
      "edit": "Edit",
      "addMember": "Add Member",
      "removeMember": "Remove Member",
      "members": "Members",
      "deactivate": "Deactivate",
      "deactivated": "Deactivated",
      "history": "History",
      "reactivate": "Reactivate"
    },
    "page": {
      "description": "Whitelist merchant cohorts allowed to peer-transfer. Manage members and per-member transfer caps. Block-from-transfer is managed in Merchant Detail."
    },
    "toast": {
      "loadFailed": "Failed to load groups",
      "networkError": "Network error",
      "checkConnection": "Check connection",
      "deactivateFailed": "Failed to deactivate group",
      "deactivated": "Group deactivated",
      "networkErrorDesc": "Network error — check connection",
      "unknownError": "Unknown error",
      "reactivated": "Group reactivated",
      "reactivateFailed": "Failed to reactivate group"
    },
    "loading": "Loading groups…",
    "empty": "No transfer groups yet. Click \"+ Create Group\" to create one.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "alreadyInactive": "Group is already inactive",
    "confirm": {
      "deactivateTitle": "Deactivate \"{{name}}\"?",
      "deactivateDesc": "The group will be marked inactive. Existing members lose transfer privileges. Re-activate via Edit later."
    },
    "form": {
      "nameRequired": "Name is required",
      "nameTooLong": "Name too long (max 80 characters)",
      "minNumber": "Min amount must be a number",
      "maxNumber": "Max amount must be a number",
      "minMax": "Min amount must be ≤ max amount",
      "nameTaken": "Group name already exists",
      "updateFailed": "Update failed",
      "createFailed": "Create failed",
      "updated": "Group updated",
      "created": "Group created",
      "editTitle": "Edit transfer group",
      "createTitle": "New transfer group",
      "nameLabel": "Name",
      "namePlaceholder": "e.g. East-Asia Hub",
      "nameHelp": "Unique across the platform. 1-80 characters.",
      "descriptionPlaceholder": "Merchants in JP/KR/CN region",
      "minAmount": "Min amount (USD)",
      "maxAmount": "Max amount (USD)",
      "cancel": "Cancel",
      "saving": "Saving…",
      "creating": "Creating…",
      "saveChanges": "Save changes",
      "createGroup": "Create group",
      "amountDecimals": "Amount allows at most 2 decimal places",
      "amountNegative": "Amount cannot be negative"
    },
    "members": {
      "loadFailed": "Failed to load members",
      "historyLoadFailed": "Failed to load history",
      "pickMerchant": "Pick a merchant from the search results",
      "alreadyMember": "This merchant is already a member.",
      "added": "Member added",
      "removeFailed": "Failed to remove member",
      "removed": "Member removed",
      "title": "Manage group — {{name}}",
      "readonlyBadge": "Inactive (read-only)",
      "membersTab": "Members ({{count}})",
      "historyTab": "History",
      "addMerchant": "Add merchant",
      "inactiveHint": "Group is inactive — re-activate via Edit to add members.",
      "searchMerchant": "Search merchant",
      "searchPlaceholder": "Search by name, email, or ID",
      "unlimited": "Unlimited (no per-member caps)",
      "maxPerTransfer": "Max per transfer (cents)",
      "maxCount": "Max count / month",
      "adding": "Adding…",
      "addMemberBtn": "Add member",
      "colMerchant": "Merchant",
      "colPerTransfer": "Per transfer",
      "colPerMonth": "Per month",
      "colStatus": "Status",
      "colActions": "Actions",
      "loadingMembers": "Loading members…",
      "noMembers": "No members yet.",
      "unlimitedValue": "Unlimited",
      "perMonthSuffix": "{{count}}/mo",
      "blocked": "Blocked",
      "blockedReason": "Blocked — {{reason}}",
      "blockedTooltip": "Blocked from transfers. Unblock via Merchant detail.",
      "remove": "Remove",
      "historyBlurb": "Recent transfers within this group. Use the cross-link for the full Transactions filter, or CSV export for an audit dump.",
      "viewInTransactions": "View in Transactions",
      "exportCsv": "Export CSV",
      "histDate": "Date",
      "histSender": "Sender",
      "histReceiver": "Receiver",
      "histAmount": "Amount",
      "loadingHistory": "Loading history…",
      "noTransfers": "No transfers yet.",
      "close": "Close",
      "noWallet": "No wallet",
      "noWalletTooltip": "This merchant has no active wallet yet — they cannot receive transfers until onboarding completes."
    },
    "history": {
      "title": "Transfer history — {{name}}",
      "loading": "Loading…",
      "empty": "No transfers routed through this group yet.",
      "date": "Date",
      "sender": "Sender",
      "recipient": "Recipient",
      "amount": "Amount",
      "note": "Note",
      "exportCsv": "Export CSV",
      "close": "Close"
    }
  },
  "topup_review": {
    "title": "Topup Review",
    "subtitle": "Manual bank transfer topups pending review",
    "columns": {
      "merchant": "Merchant",
      "amount": "Amount",
      "bank": "Bank",
      "reference": "Reference",
      "uploadedAt": "Uploaded",
      "status": "Status"
    },
    "status": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject",
      "viewProof": "View Proof"
    },
    "fields": {
      "verification": "Verification Note",
      "rejectionReason": "Rejection Reason"
    },
    "unknown": "Unknown",
    "networkError": "Network error — check connection",
    "relative": {
      "seconds": "{{count}}s ago",
      "minutes": "{{count}} min ago",
      "hours": "{{count}} hr ago",
      "days": "{{count}} day ago",
      "months": "{{count}} mo ago"
    },
    "raceLoser": {
      "title": "Already processed by another admin",
      "description": "This request was already approved/rejected by another admin — the list has refreshed."
    },
    "queue": {
      "title": "Topup Queue",
      "subtitle": "Review and approve manual topup requests (oldest first)",
      "queuePill": "Oldest first · {{count}} in queue",
      "exportCsv": "Export CSV",
      "tab": {
        "all": "All",
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected",
        "flagged": "Flagged"
      },
      "filter": {
        "merchant": "Merchant",
        "allMerchants": "All merchants",
        "gateway": "Gateway",
        "allGateways": "All gateways",
        "from": "From",
        "to": "To",
        "clear": "Clear filters"
      },
      "loading": "Loading topup queue…",
      "column": {
        "id": "ID",
        "merchant": "Merchant",
        "amount": "Amount",
        "gateway": "Gateway",
        "txId": "Tx ID",
        "date": "Date",
        "status": "Status",
        "actions": "Actions"
      },
      "flaggedTitle": "Flagged for fraud review",
      "approve": "Approve",
      "cancel": "Cancel",
      "autoWebhook": "Auto via webhook",
      "reject": "Reject",
      "review": "Review",
      "loadFailed": "Failed to load topup queue",
      "detailLoadFailed": "Failed to load request detail",
      "forceOverrideMin": "Force-approve requires a reason of at least 10 characters (audit log).",
      "approveFailed": "Approve failed",
      "approveSuccess": "Topup approved",
      "approveSuccessDesc": "Wallet credited and merchant notified.",
      "rejectReasonMin": "Rejection reason is required (min 3 characters).",
      "rejectFailed": "Reject failed",
      "rejectSuccess": "Topup rejected",
      "rejectSuccessDesc": "Merchant notified with the reason.",
      "flagFailed": "Flag toggle failed",
      "flagMarked": "Marked as suspicious",
      "flagCleared": "Flag cleared",
      "flagDesc": "Internal-only — merchant is not notified.",
      "confirmApproveTitleAmount": "Approve topup of {{amount}}?",
      "confirmApproveTitle": "Approve topup?",
      "forceApproveTier1Bold": "Force-approve tier-1.",
      "forceApproveTier1Body": "Tier-1 is usually auto-approved by webhook. A reason of at least 10 characters is required — it will be written to the audit log.",
      "confirmApproveBody": "This credits the merchant wallet and writes a ledger entry. Cannot be undone.",
      "forceOverridePlaceholder": "Force-approve reason (≥10 chars, audit log)",
      "internalNotePlaceholder": "Internal note (audit trail, optional)",
      "forceApprove": "Force approve",
      "emptyTitle": "No topup requests in this view",
      "emptyBody": "When merchants submit topup requests, they appear here for review."
    },
    "drawer": {
      "closeDrawer": "Close drawer",
      "close": "Close",
      "fallbackName": "Topup request",
      "loading": "Loading…",
      "flagged": "Flagged",
      "flagAsSuspicious": "Flag as suspicious",
      "amount": "Amount",
      "original": "Original:",
      "fxLocked": " · FX locked @ {{rate}}",
      "gateway": "Gateway",
      "tier": "Tier",
      "transactionId": "Transaction ID",
      "receipt": "Receipt",
      "openReceipt": "Open receipt",
      "download": "Download",
      "merchantNote": "Merchant note",
      "createdAt": "Created at",
      "approvedAt": "Approved at",
      "rejectedReason": "Rejected reason",
      "rejectThis": "Reject this request",
      "reason": "Reason",
      "rejectReasonPlaceholder": "Rejection reason (sent to merchant)",
      "internalNote": "Internal note (audit trail, optional)",
      "internalNotePlaceholder": "Visible to admin team only",
      "reject": "Reject",
      "approve": "Approve",
      "tier1AutoWebhook": "Tier 1 — auto via webhook",
      "forceApproveTitle": "Bypass tier-1 auto-approve (audit-logged)",
      "forceApprove": "Force approve"
    },
    "reviews": {
      "title": "Topup Reviews",
      "subtitle": "Auto-verified rows approve in one click. Manual-review rows open the 4-section proof modal.",
      "overdue": "{{count}} overdue (SLA breach)",
      "approveSuccessDescRef": "Wallet credited. Ref: {{ref}}.",
      "approveSuccessDesc": "Wallet credited.",
      "rejectSuccessDescReason": "Rejected — reason: {{reason}}.",
      "rejectSuccessDesc": "Topup rejected.",
      "loading": "Loading topup reviews…",
      "errorTitle": "Failed to load reviews.",
      "retry": "Retry",
      "emptyTitle": "No topup reviews in this view",
      "emptyBody": "Try clearing filters or switching status.",
      "merchantFallback": "Merchant …{{id}}",
      "ageMinutes": "Age: {{count}} min",
      "approving": "Approving…",
      "filter": {
        "status": "Status",
        "all": "All",
        "verification": "Verification",
        "sla": "SLA",
        "slaFresh": "Fresh (< 2h)",
        "slaYellow": "Yellow (2-4h)",
        "slaRed": "Red (> 4h)",
        "merchant": "Merchant"
      },
      "verification": {
        "auto": "Auto-verified",
        "manual": "Manual review"
      },
      "slaBadge": {
        "green": "GREEN",
        "yellow": "YELLOW",
        "red": "RED"
      },
      "column": {
        "merchant": "Merchant",
        "amount": "Amount",
        "verification": "Verification",
        "sla": "SLA",
        "created": "Created",
        "status": "Status",
        "rejectReason": "Rejection reason",
        "reviewer": "Reviewer",
        "actions": "Actions"
      },
      "cancelledByMerchant": "Cancelled by merchant"
    },
    "modal": {
      "ariaLabel": "Topup proof review",
      "title": "Topup proof review",
      "ageMinutes": "Age: {{count}} min",
      "sla": "SLA: {{age}}",
      "section1Title": "1. IMAP source",
      "section1Subtitle": "Raw bank-email body + server-parsed fields",
      "parsed": "Parsed",
      "sender": "Sender",
      "amount": "Amount",
      "memo": "Memo",
      "timestamp": "Timestamp",
      "rawImap": "Raw IMAP body",
      "noImap": "(no IMAP body captured)",
      "section2Title": "2. Merchant memo",
      "section2Subtitle": "Free-text submitted by the merchant with the topup request",
      "noMemo": "(no memo)",
      "section3Title": "3. Screenshot / bill upload",
      "section3Subtitle": "≤5MB · enforced server-side",
      "screenshotAlt": "Topup proof screenshot",
      "noScreenshot": "(no screenshot uploaded)",
      "screenshotOpen": "Open proof in new tab",
      "screenshotLoadFailed": "Could not load the proof image. Open it in a new tab below.",
      "section4Title": "4. Wallet context",
      "section4Subtitle": "Balance snapshot · recent transactions · suspicious flags",
      "walletBalance": "Wallet balance",
      "suspiciousFlags": "Suspicious flags",
      "recentTransactions": "Recent transactions",
      "noTransactions": "(no recent transactions in window)",
      "approveNotes": "Approve notes (optional)",
      "approveNotesPlaceholder": "Optional internal note — written to audit log",
      "rejectThis": "Reject this topup",
      "rejectReasonAria": "Reject reason",
      "selectReason": "Select reason…",
      "freeTextPlaceholder": "Free-text reason (required)",
      "cancel": "Cancel",
      "reject": "Reject",
      "approve": "Approve",
      "selectReasonError": "Please select a rejection reason.",
      "otherRequiredError": "A reason is required when selecting \"Other\".",
      "rejectReason": {
        "wrong_amount": "Wrong amount",
        "wrong_memo": "Wrong memo",
        "unknown_sender": "Unknown sender",
        "duplicate": "Duplicate",
        "suspicious": "Suspicious",
        "missing_proof": "Missing proof",
        "other": "Other (free-text required)"
      }
    }
  },
  "credit": {
    "title": "Credits",
    "subtitle": "Cross-merchant credit balances",
    "columns": {
      "merchant": "Merchant",
      "balance": "Balance",
      "lastTopup": "Last Topup",
      "lifetime": "Lifetime Spend",
      "amount": "Amount",
      "used": "Used",
      "remaining": "Remaining",
      "expiresAt": "Expires At",
      "reason": "Reason",
      "createdBy": "Created By",
      "version": "Version",
      "status": "Status",
      "actions": "Actions"
    },
    "actions": {
      "grant": "Grant Credit",
      "revoke": "Revoke",
      "viewHistory": "View History"
    },
    "filters": {
      "merchant": "Merchant",
      "minBalance": "Min Balance",
      "maxBalance": "Max Balance",
      "merchantLabel": "Merchant (search by name / email)",
      "merchantPlaceholder": "All merchants",
      "clear": "Clear filters",
      "statusLabel": "Status",
      "statusAria": "Credit status",
      "expiryLabel": "Expiry within",
      "expiryAria": "Expiry range"
    },
    "listSubtitle": "Cross-merchant credits — versioned records, consumed FIFO from the oldest non-expired credit.",
    "loading": "Loading credits…",
    "status": {
      "active": "Active",
      "used": "Used",
      "expired": "Expired",
      "revoked": "Revoked",
      "all": "All"
    },
    "expiry": {
      "any": "Any",
      "withinDays": "≤ {{days}} days"
    },
    "empty": {
      "title": "No credits cross-merchants.",
      "bodyBefore": "Open a merchant's detail then go to the",
      "tabName": "Credit",
      "bodyAfter": "tab to grant / edit / revoke credit for that merchant."
    },
    "errors": {
      "loadFailed": "Failed to load the credit list"
    },
    "revoke": {
      "successTitle": "Credit revoked",
      "successDesc": "History has been updated.",
      "reasonRequired": "Reason required — 10 to 500 characters.",
      "failedTitle": "Failed to revoke credit",
      "dialogTitle": "Revoke credit",
      "merchantLabel": "Merchant:",
      "warning": "Current version: v{{version}}. Used credit is still owed — the merchant must still pay the amount already used. This action cannot be undone.",
      "reasonLabel": "Revocation reason (10–500 characters)",
      "charsNeeded": "{{count}} more characters needed",
      "lengthOk": "Length OK",
      "cancel": "Cancel",
      "submitting": "Revoking…",
      "submit": "Revoke"
    }
  },
  "gateway": {
    "title": "Payment Gateways",
    "subtitle": "Gateway configuration and routing",
    "columns": {
      "name": "Gateway",
      "type": "Type",
      "isActive": "Active",
      "priority": "Priority"
    },
    "actions": {
      "configure": "Configure",
      "enable": "Enable",
      "disable": "Disable",
      "testConnection": "Test Connection"
    },
    "errors": {
      "testFailed": "Connection test failed",
      "missingCredentials": "Gateway credentials are not configured"
    },
    "surfaces": {
      "ariaLabel": "Gateway surfaces",
      "tabP8": "Payment Gateways",
      "tabP3": "Gateway Settings (9 providers)"
    },
    "settings": {
      "toast": {
        "savedTitle": "Gateway configuration saved",
        "saveFailedTitle": "Could not save configuration",
        "webhookRegeneratedTitle": "Webhook secret regenerated",
        "webhookRegeneratedDesc": "Update the new secret in the gateway dashboard so webhooks continue to verify.",
        "webhookRegenerateFailedTitle": "Could not regenerate webhook",
        "webhookCopiedTitle": "Webhook URL copied"
      },
      "loading": "Loading {{gateway}} configuration…",
      "loadFailedPrefix": "Could not load:",
      "tierLockedTier1": "Tier 1 gateway — hot-swap is not supported.",
      "tierLockedTier2": "Tier 2 gateway — hot-swap is not supported.",
      "savingShort": "Saving…",
      "save": "Save",
      "networkError": "Network error — check connection",
      "pauseDialog": {
        "titlePause": "Pause gateway {{gateway}}?",
        "titleResume": "Resume gateway {{gateway}}?",
        "descPause": "The BullMQ queue will pause and the merchant portal will show the \"Maintenance\" badge. A reason (≥{{min}} characters) is required for the audit log.",
        "descResume": "The BullMQ queue will resume automatically. Notes are optional.",
        "reasonLabelPause": "Reason (≥{{min}} characters)",
        "reasonLabelResume": "Notes (optional)",
        "reasonPlaceholderPause": "e.g. Suspected fraud spike — holding for investigation",
        "reasonPlaceholderResume": "e.g. Health check has been stable for 5 minutes",
        "reasonTooShort": "Reason must be at least {{min}} characters (currently {{count}}).",
        "cancel": "Cancel",
        "processing": "Processing…",
        "confirmPause": "Pause",
        "confirmResume": "Resume"
      },
      "pauseBanner": "Queue is paused — merchant portal shows the \"Maintenance\" badge. No auto-switch to another gateway.",
      "card": {
        "auditNotice": "Each reveal is written to the audit log and auto-hides after 30 seconds.",
        "statusHeading": "Status",
        "pause": "Pause",
        "resume": "Resume",
        "apiKey": "API key",
        "reveal": "Reveal",
        "statusLabel": "Status",
        "autoApprove": "Auto-approve",
        "yes": "Yes",
        "no": "No",
        "lastHealthCheck": "Last health check"
      },
      "toastP8": {
        "pausedTitle": "Paused {{gateway}}",
        "resumedTitle": "Resumed {{gateway}}",
        "networkError": "Network error — check your connection.",
        "alreadyPausedTitle": "Gateway already paused",
        "pauseFailedTitle": "Could not pause",
        "notPausedTitle": "Gateway is not in paused state",
        "resumeFailedTitle": "Could not resume"
      },
      "panel": {
        "statusFilterLabel": "Status",
        "statusFilterAll": "All",
        "loadingList": "Loading gateway list…",
        "loadFailedPrefix": "Could not load:",
        "loadFailedUnknown": "unknown error",
        "empty": "No payment gateway in this status yet.",
        "heading": "Payment Gateways",
        "subtitle": "Platform-global gateway config — masked credentials, fee mode, pause/resume, 60s health poll.",
        "statusEnabled": "Enabled",
        "statusPaused": "Paused",
        "statusDisabled": "Disabled"
      },
      "test": {
        "healthyTitle": "Healthy",
        "failedTitle": "Test failed",
        "nonOk": "Gateway returned non-OK",
        "connFailedTitle": "Test connection failed",
        "testing": "Testing…",
        "testConnection": "Test connection"
      },
      "health": {
        "untestedTitle": "No live health check yet — click Test connection to ping this gateway.",
        "untested": "Untested",
        "healthy": "Healthy",
        "degraded": "Degraded",
        "down": "Down"
      },
      "legacy": {
        "heading": "Gateway Settings (Legacy 9-plugin)",
        "subtitle": "Per-gateway: enable, tier mode, credentials, health check"
      },
      "fields": {
        "enabled": "Enabled",
        "tierMode": "Tier mode"
      },
      "tierOption": {
        "instant": "Instant (Tier 1{{lockSuffix}})",
        "manual": "Manual + IMAP (Tier 2{{lockSuffix}})",
        "lockedSuffix": " — locked"
      },
      "credentials": {
        "heading": "Credentials (encrypted)",
        "placeholder": "Enter credential",
        "fields": {
          "clientId": "Client ID",
          "clientSecret": "Client Secret",
          "publishableKey": "Publishable Key",
          "secretKey": "Secret Key",
          "webhookSecret": "Webhook Secret",
          "apiKey": "API Key",
          "partnerId": "Partner ID",
          "merchantId": "Merchant ID",
          "apiKeyOptional": "API Key (optional)"
        }
      },
      "webhook": {
        "heading": "Webhook URL",
        "copy": "Copy",
        "regenerate": "Regenerate"
      },
      "imapPreview": {
        "heading": "IMAP pattern preview",
        "sender": "Sender",
        "txnId": "Txn ID",
        "amount": "Amount",
        "editLink": "Edit in IMAP Config →"
      },
      "recentTx": {
        "heading": "Recent transactions",
        "empty": "No recent transactions",
        "colTxId": "Tx ID",
        "colAmount": "Amount",
        "colStatus": "Status",
        "colDate": "Date"
      },
      "regenConfirm": {
        "title": "Regenerate webhook secret?",
        "desc": "Existing integrations using the old secret will fail until updated. Action cannot be undone.",
        "confirm": "Regenerate"
      },
      "p8health": {
        "lastCheck": "Last health check {{at}}",
        "noProbe": "No probe yet",
        "maintenance": "Maintenance (paused)",
        "healthy": "Healthy",
        "degraded": "Degraded",
        "down": "Down"
      }
    },
    "feeForm": {
      "heading": "Fee configuration — {{gateway}}",
      "subtitle": "The vendor bears the gateway fee. Every change requires a reason for the audit log.",
      "modeLabel": "Fee model",
      "mode": {
        "flat": "Flat — fixed fee ($X)",
        "percent": "Percentage — percent (Y%)",
        "combined": "Combined — $X + Y%"
      },
      "flatLabel": "Flat fee (USD)",
      "percentLabel": "Percent fee (%)",
      "previewLabel": "Applied fee:",
      "reasonLabel": "Reason for change",
      "reasonPlaceholder": "e.g. Adjusted per vendor contract Q2",
      "saving": "Saving…",
      "submit": "Save fee configuration",
      "toast": {
        "updatedTitle": "Fee configuration updated",
        "auditLog": "Audit log: {{id}}",
        "saveFailedTitle": "Could not save fee configuration",
        "networkError": "Network error — check connection."
      },
      "errors": {
        "reasonMin": "Reason for change must be ≥ 5 characters",
        "flatMin": "Flat fee must be ≥ $0.00",
        "percentRange": "Percent fee must be between 0% and 100%",
        "combinedBoth": "Combined mode needs both flat and percent > 0",
        "flatRequired": "Flat mode needs a fee > $0.00",
        "percentRequired": "Percent mode needs a fee > 0%"
      }
    },
    "reveal": {
      "ariaLabel": "Reveal API key — {{gateway}}",
      "title": "Reveal API key — {{gateway}}",
      "subtitle": "Every reveal is written to the audit log. The key auto-hides after {{seconds}} seconds.",
      "passwordLabel": "Your password",
      "passwordPlaceholder": "At least 8 characters",
      "cancel": "Cancel",
      "verifying": "Verifying…",
      "submit": "Reveal",
      "autoHidePrefix": "Auto-hides in",
      "autoHideSuffix": ". Audit log recorded.",
      "apiKeyLabel": "API key",
      "copy": "Copy",
      "hideNow": "Hide now",
      "toast": {
        "maskedTitle": "API key hidden",
        "maskedDesc": "The API key was hidden automatically after the viewing window.",
        "revealedTitle": "API key revealed",
        "revealedDesc": "The key will auto-hide after {{seconds}}s — audit logged.",
        "rateLimitedTitle": "Too many attempts",
        "rateLimitedDesc": "Please wait a few minutes and try again.",
        "revealFailedTitle": "Could not reveal API key",
        "networkError": "Network error — check connection.",
        "copied": "API key copied"
      },
      "errors": {
        "passwordInvalid": "Confirmation password is incorrect"
      }
    }
  },
  "payout": {
    "title": "Payouts",
    "subtitle": "Vendor payout queue",
    "columns": {
      "vendor": "Vendor",
      "amount": "Amount",
      "period": "Period",
      "method": "Method",
      "status": "Status"
    },
    "status": {
      "pending": "Pending",
      "processing": "Processing",
      "paid": "Paid",
      "failed": "Failed",
      "cancelled": "Cancelled"
    },
    "actions": {
      "process": "Process",
      "retry": "Retry",
      "cancel": "Cancel"
    },
    "withdraw": {
      "relative": {
        "justNow": "just now",
        "minutes": "{{count}} min ago",
        "hours": "{{count}} hr ago",
        "days": "{{count}} day ago"
      },
      "tab": {
        "all": "All",
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected"
      },
      "status": {
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected",
        "cancelled": "Cancelled"
      },
      "raceLoser": {
        "title": "Already processed by another admin",
        "description": "This request was already approved or rejected — the list will reload.",
        "descriptionShort": "This request was already approved or rejected."
      },
      "networkErrorTitle": "Network error",
      "checkConnection": "Check connection",
      "loadFailed": "Failed to load withdraw queue",
      "page": {
        "title": "Merchant Withdrawals",
        "subtitle": "Approve or reject merchant withdraw requests (vendor payouts are under Vendor Payouts)"
      },
      "filterAria": "Withdraw status filter",
      "column": {
        "merchant": "Merchant",
        "amount": "Amount",
        "bankAccount": "Bank Account",
        "date": "Date",
        "actions": "Actions"
      },
      "loading": "Loading…",
      "emptyPending": "No pending withdraw requests",
      "emptyAll": "No requests found",
      "emptyStatus": "No {{status}} requests found",
      "cancel": "Cancel",
      "view": "View",
      "close": "Close",
      "field": {
        "amount": "Amount",
        "bankAccount": "Bank account"
      },
      "internalNoteLabel": "Internal note (optional)",
      "approve": {
        "refRequired": "Bank wire reference is required",
        "refTooLong": "Reference too long (max {{max}} chars)",
        "ledgerMissingTitle": "Cannot approve — ledger missing",
        "ledgerMissingDesc": "This pending record has no matching hold ledger entry (data error). Contact ops to re-seed or cancel.",
        "failed": "Approve failed",
        "successTitle": "Withdraw approved",
        "title": "Approve withdraw — {{merchant}}",
        "refLabel": "Bank wire reference",
        "refPlaceholder": "e.g. WF-WIRE-20260429-7788",
        "refHelp": "Required — paste the external bank/wire ID after sending the transfer (audit trail).",
        "internalNotePlaceholder": "Wire sent via Wells Fargo…",
        "submitting": "Approving…",
        "submit": "Approve"
      },
      "reject": {
        "reasonMin": "Reason is required (min {{min}} characters)",
        "reasonMax": "Reason too long (max {{max}} characters)",
        "failed": "Reject failed",
        "successTitle": "Withdraw rejected",
        "title": "Reject withdraw — {{merchant}}",
        "reasonLabel": "Reason",
        "reasonHelp": "Visible to merchant. 3-500 characters.",
        "internalNotePlaceholder": "Asked merchant to provide updated SWIFT…",
        "submitting": "Rejecting…",
        "submit": "Reject"
      },
      "detail": {
        "title": "Withdraw request — {{merchant}}",
        "merchant": "Merchant",
        "amount": "Amount",
        "bankAccount": "Bank account",
        "status": "Status",
        "requested": "Requested",
        "approved": "Approved",
        "wireRef": "Wire ref",
        "rejectReason": "Reject reason"
      }
    },
    "markTransferred": {
      "ariaLabel": "Mark as transferred — {{vendor}}",
      "title": "Mark as transferred — {{vendor}}",
      "subtitleBefore": "The payout will move to ",
      "completedLabel": "Completed",
      "subtitleAfter": " status. This action is recorded in the audit log.",
      "invalidFormat": "Invalid format. Only PDF, JPG or PNG are accepted.",
      "fileTooLarge": "File exceeds the 5MB limit (currently {{size}}MB).",
      "refTooShort": "A transfer reference is required (minimum {{min}} characters).",
      "refTooLong": "Transfer reference is too long (maximum {{max}} characters).",
      "refRequired": "A transfer reference is required",
      "uploadFailed": "Proof upload failed. You can remove the attachment and try again, or contact ops.",
      "clearFile": "Remove",
      "cancel": "Cancel",
      "submit": "Mark Completed",
      "submitting": "Processing…",
      "fields": {
        "netAmount": "Amount (net)",
        "vendor": "Vendor",
        "transferRef": "Transfer reference",
        "transferRefPlaceholder": "e.g. WIRE-20260517-0042",
        "transferRefHelp": "Required — paste the wire / SWIFT confirmation after transferring.",
        "proof": "Bank statement proof (optional)",
        "proofHelp": "PDF, JPG or PNG. Max 5MB. The file is stored and its link appears in the payout details.",
        "notes": "Notes (optional)",
        "notesPlaceholder": "e.g. Confirmed on the bank portal at 14:32."
      },
      "toast": {
        "successTitle": "Marked as Transferred",
        "successDesc": "Payout {{vendor}} ({{amount}}) moved to Completed.",
        "staleTitle": "Payout status changed",
        "staleDesc": "The payout is no longer in Processing — the list will reload.",
        "failTitle": "Could not mark as Transferred",
        "networkErrorTitle": "Network error",
        "networkErrorDesc": "Check your connection and try again."
      }
    },
    "errors": {
      "network": "Network error — check connection",
      "unknown": "Unknown error"
    }
  },
  "transaction": {
    "title": "Transactions",
    "subtitle": "Cross-merchant transaction ledger",
    "columns": {
      "id": "Transaction ID",
      "merchant": "Merchant",
      "type": "Type",
      "amount": "Amount",
      "gateway": "Gateway",
      "createdAt": "Created",
      "status": "Status",
      "direction": "Dir",
      "merchantVendor": "Merchant / Vendor",
      "description": "Description"
    },
    "type": {
      "topup": "Topup",
      "charge": "Charge",
      "refund": "Refund",
      "adjustment": "Adjustment",
      "withdrawal": "Withdrawal",
      "topup_credit": "Topup credit",
      "order_charge": "Order charge",
      "refund_debit": "Refund debit",
      "credit_grant": "Credit grant",
      "credit_use": "Credit use",
      "payout_debit": "Payout debit",
      "gateway_fee": "Gateway fee",
      "manual_adjustment": "Manual adjustment",
      "invoice_payment": "Invoice payment",
      "credit_memo_apply": "Credit memo apply",
      "pre_payment": "Pre-payment",
      "transfer_in": "Transfer in",
      "transfer_out": "Transfer out",
      "chargeback": "Chargeback"
    },
    "status": {
      "succeeded": "Succeeded",
      "pending": "Pending",
      "failed": "Failed",
      "reversed": "Reversed",
      "completed": "Completed"
    },
    "filters": {
      "type": "Type",
      "gateway": "Gateway",
      "dateFrom": "From",
      "dateTo": "To",
      "amountMin": "Min Amount",
      "amountMax": "Max Amount",
      "merchant": "Merchant",
      "allMerchants": "All merchants",
      "vendor": "Vendor",
      "allVendors": "All vendors",
      "status": "Status",
      "allStatuses": "All statuses",
      "linkedOrderId": "Linked Order ID",
      "linkedOrderIdPlaceholder": "Paste an order ID",
      "linkedAdjustmentId": "Linked Adjustment / Credit-Memo ID",
      "linkedAdjustmentIdPlaceholder": "Paste an adjustment / credit-memo ID",
      "typeSelected": "Transaction type ({{count}}/14 selected)",
      "clearTypes": "Clear types",
      "typeAria": "Transaction type filter",
      "clearAll": "Clear all filters"
    },
    "page": {
      "description": "Cross-merchant / vendor ledger. Read-only — every entry originates from its source surface (topup approval, refund, payout, …)."
    },
    "toast": {
      "loadFailed": "Failed to load transactions",
      "unknownError": "Unknown error"
    },
    "summary": {
      "totalIn": "Total In",
      "totalOut": "Total Out",
      "net": "Net",
      "pending": "Pending"
    },
    "loading": "Loading…",
    "empty": "No transactions match the current filters.",
    "savedViews": {
      "label": "Saved views:",
      "last24h": "Last 24h",
      "clear": "Clear chip"
    },
    "search": {
      "label": "Search",
      "placeholder": "id / description / merchant / vendor"
    },
    "direction": {
      "in": "In",
      "out": "Out"
    },
    "row": {
      "merchantLabel": "M:",
      "vendorLabel": "V:",
      "invoiceLabel": "invoice:",
      "orderLabel": "order:",
      "creditMemoLabel": "credit memo:"
    },
    "detail": {
      "back": "Transactions",
      "title": "Transaction detail",
      "loading": "Loading…",
      "notFound": "Transaction not found.",
      "directionIn": "Money in",
      "directionOut": "Money out",
      "order": "Order",
      "invoice": "Invoice",
      "time": "Time",
      "linesHeading": "Ledger entries (double-entry)",
      "account": "Account"
    }
  },
  "merchant_billing": {
    "title": "Merchant Billing",
    "subtitle": "Per-merchant billing configuration",
    "tabs": {
      "config": "Configuration",
      "invoices": "Invoices",
      "credits": "Credits",
      "history": "History"
    },
    "fields": {
      "billingMode": "Billing Mode",
      "currency": "Currency",
      "withdrawEnabled": "Withdraw Enabled",
      "creditLimit": "Credit Limit",
      "paymentTerms": "Payment Terms (days)",
      "legalEntity": "Legal Entity"
    },
    "actions": {
      "save": "Save Changes",
      "reset": "Reset"
    },
    "loading": "Loading…",
    "merchantWithId": "Merchant {{id}}",
    "viewAllInvoices": "View all invoices",
    "errors": {
      "generic": "Something went wrong",
      "loadConfigFailed": "Failed to load billing config",
      "networkErrorTitle": "Network error",
      "networkError": "Network error - check connection",
      "loadInvoicesFailed": "Failed to load invoice history",
      "missingMerchantId": "Missing merchant id in URL."
    },
    "mode": {
      "heading": "Billing mode",
      "subheading": "Switch between PREPAID, CREDIT, and INVOICE billing.",
      "quickSwitchLabel": "Billing mode (quick switch)",
      "selectPlaceholder": "Select mode…",
      "creditHint": "Use the full options below to pick CREDIT mode.",
      "ariaLabel": "Billing mode",
      "walletFreezeWarning": "Wallet will be frozen on switch to INVOICE mode. Existing wallet balance stays in escrow until refunded.",
      "reasonLabel": "Reason (audit log)",
      "reasonPlaceholder": "Why are you switching mode?",
      "adminOnly": "Admin only",
      "switching": "Switching…",
      "saveBtn": "Save mode",
      "switchFailed": "Mode switch failed",
      "versionStaleTitle": "Mode version stale",
      "updatedTitle": "Billing mode updated",
      "updatedDesc": "Switched to {{mode}}"
    },
    "modeOption": {
      "PREPAID": {
        "label": "Prepaid (wallet)",
        "description": "Merchant tops up a wallet balance up-front. No invoices issued."
      },
      "CREDIT": {
        "label": "Credit (auto-recharge)",
        "description": "Wallet auto-recharged from saved gateway. Failed recharge → suspend."
      },
      "INVOICE": {
        "label": "Invoice (NET terms)",
        "description": "Periodic invoices generated per cycle. Merchant pays NET-N days after issue."
      }
    },
    "cycle": {
      "WEEKLY": "Weekly",
      "BIWEEKLY": "Biweekly",
      "MONTHLY": "Monthly"
    },
    "paymentMethod": {
      "BANK_TRANSFER": "Bank transfer",
      "GATEWAY": "Payment gateway"
    },
    "invoiceStatus": {
      "DRAFT": "Draft",
      "SENT": "Sent",
      "PENDING_APPROVAL": "Pending",
      "PAID": "Paid",
      "PARTIAL": "Partial",
      "OVERDUE": "Overdue",
      "VOIDED": "Void"
    },
    "outstanding": {
      "heading": "Outstanding",
      "subheading": "Gross and net outstanding (soft cap).",
      "gross": "Gross outstanding",
      "net": "Net outstanding",
      "netHint": "After applying active credit memos",
      "softLimit": "Soft limit",
      "overCap": "Over soft cap — orders may be blocked",
      "noSoftLimit": "No soft limit configured."
    },
    "config": {
      "heading": "Billing configuration",
      "subheading": "Cycle, due days, credit limit, and payment methods. Applies to INVOICE mode merchants.",
      "invoiceOnly": "Billing config only applies to INVOICE mode merchants. Switch mode first.",
      "cycleLabel": "Cycle",
      "dueDaysLabel": "Due days (1–90)",
      "dueDayTypeLabel": "Due day type",
      "dueDayTypeHelp": "Business days = skip Saturday/Sunday. Recommended for B2B per industry standard.",
      "businessDays": "Business days",
      "businessDaysHint": "(recommended — skip weekends + entity holidays)",
      "calendarDays": "Calendar days",
      "calendarDaysHint": "(simple date addition)",
      "softLimitLabel": "Soft limit / Credit limit (USD, optional)",
      "softLimitPlaceholder": "e.g. 50000",
      "paymentMethodsLabel": "Payment methods",
      "withdrawLabel": "Withdraw permission",
      "withdrawManageTip": "Manage in Wallet tab",
      "withdrawEnterpriseTip": "Withdraw is Enterprise-tier only",
      "withdrawDesc": "Allow merchant to withdraw wallet balance",
      "withdrawTierHint": "— Enterprise tier only (current: {{tier}})",
      "saving": "Saving…",
      "saveBtn": "Save config",
      "validationFailed": "Validation failed",
      "saveFailed": "Failed to save billing config",
      "savedTitle": "Billing config saved",
      "savedDesc": "Updated for {{name}}",
      "merchantFallback": "merchant",
      "errors": {
        "dueDays": "Due days must be between 1 and 90",
        "paymentMethods": "Pick at least one payment method",
        "softLimit": "Soft limit must be a non-negative number"
      }
    },
    "invoices": {
      "heading": "Recent invoices",
      "subheading": "Past invoices for this merchant. View all in the cross-merchant Invoices page.",
      "viewAll": "View all",
      "columns": {
        "number": "Invoice #",
        "period": "Period",
        "amount": "Amount",
        "status": "Status",
        "due": "Due",
        "actions": "Actions"
      },
      "loading": "Loading invoices…",
      "empty": "No invoices found for this merchant",
      "view": "View"
    },
    "settlement": {
      "title": "Settle outstanding before mode switch",
      "outstandingGross": "Outstanding (gross)",
      "creditsAvailable": "Active credit memos available",
      "activeMemos": "Active credit memos ({{count}})",
      "convertTitle": "Settle now — convert credit memos → wallet",
      "convertDesc": "Move {{amount}} from credit memos into the merchant wallet, then switch mode.",
      "carryTitle": "Carry forward — apply credits → outstanding, then switch",
      "carryDesc": "Apply {{amount}} to outstanding invoices first, then switch mode.",
      "insufficientInline": "Still {{amount}} outstanding — pick another option or pay the remainder first.",
      "refundTitle": "Refund credit memos to bank",
      "refundDesc": "Open a refund task ({{amount}}) for finance to wire back to merchant bank, then switch mode.",
      "cancelTitle": "Cancel — keep current mode",
      "cancelDesc": "Don't switch. Resolve outstanding manually first.",
      "close": "Close",
      "confirm": "Confirm switch to {{mode}}",
      "insufficientTitle": "Insufficient credit memos",
      "insufficientDesc": "Still {{amount}} outstanding after applying credits — pick another settlement option.",
      "requiredTitle": "Settlement required"
    }
  },
  "manual_generate": {
    "backToInvoices": "Back to Invoices",
    "heading": "Generate Manual Invoice",
    "subtitlePrefix": "Override automated cycle generation for ad-hoc charges or corrections. Manual invoices are numbered",
    "subtitleSuffix": ".",
    "steps": {
      "compose": "Compose",
      "preview": "Preview & Confirm"
    },
    "merchantLabel": "Merchant",
    "merchantPlaceholder": "Select INVOICE-mode merchant…",
    "merchantHintPrefix": "Only merchants on INVOICE billing mode are listed (server filter",
    "merchantHintSuffix": ").",
    "merchantInfo": {
      "title": "Merchant info",
      "name": "Name:",
      "phone": "Phone:",
      "email": "Email:",
      "businessName": "Business name:",
      "taxId": "Tax ID:",
      "address": "Address:"
    },
    "storeLabel": "Store",
    "storeAll": "— All stores —",
    "gatewayLabel": "Payment Gateway",
    "gatewayAll": "— All gateways —",
    "cycleStartLabel": "Cycle Window Start",
    "cycleEndLabel": "Cycle Window End",
    "rangeHint": "Range: {{days}} days (max {{max}})",
    "taxLabel": "Custom Tax Amount (USD, optional)",
    "taxPlaceholder": "e.g. 12.50",
    "taxHint": "Leave empty for auto-compute. The tax engine is deferred to a later phase; a manual override is allowed for B2B invoices.",
    "markupLabel": "Unit-price markup (%)",
    "markupPlaceholder": "e.g. 5.0",
    "markupHint": "Applied to every line-item unit price before tax.",
    "legalEntityLabel": "Legal entity",
    "legalEntityDefault": "— Default —",
    "legalEntityDefaultSuffix": " — default",
    "timezoneLabel": "Timezone",
    "notesLabel": "Internal Note (admin-only)",
    "notesPlaceholder": "Reason for manual override…",
    "notesCount": "{{count}}/500",
    "cancel": "Cancel",
    "preview": "Preview",
    "previewPanel": {
      "numberingPreview": "Numbering preview:",
      "merchant": "Merchant",
      "billingMode": "Billing Mode",
      "cycleWindow": "Cycle Window",
      "cycleDays": "({{days}}d)",
      "tax": "Tax",
      "internalNote": "Internal Note",
      "workerNotice": "The worker may take a few seconds. Subtotal and final total are aggregated by the backend invoice-generation worker; this preview reflects what you typed, not the computed totals."
    },
    "backToEdit": "Back to edit",
    "generating": "Generating…",
    "confirmGenerate": "Confirm & Generate",
    "taxAuto": "Auto (computed by the worker — deferred to a later phase)",
    "taxManual": "{{amount}} (manual override)",
    "errors": {
      "cycleEndOrder": "Cycle End must be on or after Cycle Start.",
      "rangeMax": "Date range must be ≤ {{max}} days (current {{days}}d).",
      "taxInvalid": "Tax amount must be a non-negative number with up to 2 decimals.",
      "completeBeforePreview": "Please complete merchant + cycle window before preview.",
      "formInvalid": "Form is invalid.",
      "noTransactions": "There are no orders in this period — the invoice would be empty. Change the period or wait for the merchant to generate orders."
    },
    "toast": {
      "noTransactionsTitle": "No data in the period",
      "failTitle": "Failed to generate invoice",
      "successTitle": "Invoice generation enqueued · {{number}}",
      "successDesc": "Merchant {{merchant}} — period {{from}} → {{to}}. The new invoice will appear in the list once the worker finishes.",
      "networkTitle": "Network error"
    }
  },
  "fraud": {
    "page": {
      "heading": "Fraud Settings",
      "subtitle": "Velocity limits, suspicious topup rules, cooling periods"
    },
    "loading": "Loading configuration…",
    "loadFailedPrefix": "Could not load configuration:",
    "unknown": "unknown",
    "velocity": {
      "heading": "Velocity Limits",
      "maxWithdraw": "Max withdraws / day per merchant",
      "maxWithdrawHint": "Maximum USD withdrawn per day (whole dollars)",
      "maxTopup": "Max topup requests / day per merchant"
    },
    "suspicious": {
      "heading": "Suspicious Topup Flag",
      "countThreshold": "Pending count threshold",
      "amountThreshold": "Total amount threshold (USD)"
    },
    "cooling": {
      "heading": "Cooling Period",
      "defaultDays": "Default cooling days after withdraw approve",
      "defaultDaysHint": "Set 0 to disable cooling globally"
    },
    "overrides": {
      "heading": "Per-merchant overrides",
      "description": "Find a merchant by name / email → customize velocity / cooling independently of the global default. Overrides take precedence over the global value.",
      "merchantPlaceholder": "Select merchant…",
      "open": "Open overrides",
      "merchantLabel": "Merchant:",
      "loading": "Loading override…",
      "maxTopup": "Max topup requests / day (override, leave blank = inherit)",
      "maxWithdraw": "Max withdraw / day USD (override)",
      "coolingDays": "Cooling period override (days, 0 = disable cooling)",
      "cancel": "Cancel",
      "saving": "Saving…",
      "save": "Save override"
    },
    "discard": "Discard",
    "saving": "Saving…",
    "saveChanges": "Save Changes",
    "toast": {
      "savedTitle": "Fraud configuration saved",
      "saveFailedTitle": "Could not save configuration",
      "networkError": "Network error — check connection",
      "overrideSavedTitle": "Merchant override saved",
      "overrideFailedTitle": "Could not save override",
      "noMerchantTitle": "No merchant selected",
      "noMerchantDesc": "Please select a merchant before opening overrides"
    }
  },
  "fx_rate": {
    "page": {
      "heading": "FX Rates",
      "subtitle": "Per-gateway exchange rates (click a cell to edit). Stale ≥{{days}} days flagged red."
    },
    "addCurrency": "+ Add Currency",
    "failedToLoad": "Failed to load",
    "allowed": {
      "heading": "Allowed Currencies",
      "description": "ISO-4217 codes that merchants are allowed to top up. Add/remove then click Save.",
      "saving": "Saving…",
      "save": "Save",
      "loading": "Loading…",
      "empty": "No currencies allowed yet.",
      "removeAria": "Remove {{code}}",
      "addLabel": "Add ISO-4217 code",
      "add": "+ Add",
      "unsavedHint": "You have unsaved changes — click Save above."
    },
    "table": {
      "loading": "Loading FX rates…",
      "empty": "No FX rates configured yet",
      "colCurrency": "Currency",
      "colLastUpdated": "Last updated",
      "markStale": "Mark stale"
    },
    "confirm": {
      "markStale": "Mark {{currency}} as stale?"
    },
    "modal": {
      "title": "Add Currency",
      "codeLabel": "ISO-4217 code (e.g., USD, EUR)",
      "gatewayLabel": "Gateway",
      "gatewayPlaceholder": "paypal | stripe | sunrate | …",
      "rateLabel": "Initial rate (6-decimal, e.g., 1.080000)",
      "cancel": "Cancel",
      "add": "Add"
    },
    "age": {
      "today": "today",
      "oneDayAgo": "1 day ago",
      "daysAgo": "{{days}} days ago",
      "daysStale": "{{days}} days (stale)"
    },
    "toast": {
      "isoInvalid": "ISO-4217 code must be 3 letters A-Z",
      "isoInvalidShort": "ISO-4217 code must be 3 characters",
      "alreadyInList": "{{code}} is already in the list",
      "allowedSaved": "Allowed currencies list saved",
      "allowedSaveFailed": "Could not save allowed currencies",
      "networkError": "Network error — check connection",
      "rateSaved": "Rate saved",
      "rateSaveFailed": "Could not save rate",
      "markedStale": "Rate marked as stale",
      "markStaleFailed": "Could not mark as stale",
      "invalidRate": "Invalid rate",
      "invalidRateDesc": "Must be a positive number (e.g., 1.080000)",
      "gatewayRequired": "A gateway is required"
    }
  },
  "imap": {
    "page": {
      "heading": "IMAP Configuration",
      "subtitle": "Bank email parser — connects to the receipt mailbox and extracts transaction details"
    },
    "tabs": {
      "connection": "Connection",
      "matrix": "Per-gateway parsers",
      "logs": "Logs"
    },
    "connection": {
      "heading": "Connection",
      "host": "Host",
      "port": "Port",
      "secure": "Secure (SSL/TLS)",
      "secureHint": "Use SSL/TLS (encrypt the connection to the mailbox)",
      "namespacePlaceholder": "e.g. printway-bank-receipts",
      "namespaceHint": "Idempotency source identifier — the generic word \"imap\" is not allowed.",
      "email": "Email",
      "password": "App password",
      "passwordPlaceholder": "Enter app password",
      "pollInterval": "Poll interval (1–15 min)",
      "pollCurrent": "Currently: {{minutes}} minutes"
    },
    "fields": {
      "sourceNamespace": "Source namespace"
    },
    "parserTest": {
      "heading": "Parser Test",
      "gatewayLabel": "Gateway parser",
      "testing": "Testing…",
      "testButton": "Test parse",
      "samplePlaceholder": "Paste sample email here...",
      "resultHeading": "Parsed result",
      "matchYes": "Match: yes",
      "txId": "Tx ID",
      "amount": "Amount",
      "none": "(none)",
      "wouldLinkLabel": "Would link to request",
      "noMatchingRequest": "No matching pending request",
      "matchNo": "Match: no — sender/txn/amount regex did not match this sample.",
      "runHint": "Run test to preview parser output"
    },
    "matrix": {
      "heading": "Per-gateway regex matrix",
      "description": "Each Tier 2 gateway needs 3 regexes: sender filter, txn ID extractor, amount extractor.",
      "colGateway": "Gateway",
      "colSender": "Sender regex",
      "colTxnId": "Txn ID regex",
      "colAmount": "Amount regex",
      "senderPlaceholder": "^noreply@...",
      "txnIdPlaceholder": "Transaction ID:\\\\s*([A-Z0-9-]+)",
      "amountPlaceholder": "Amount:\\\\s*\\\\$?([0-9,.]+)"
    },
    "logs": {
      "heading": "Parse history (last 100)",
      "loading": "Loading logs…",
      "loadFailed": "Failed to load logs",
      "empty": "No parse activity yet.",
      "colDate": "Date",
      "colSender": "Sender",
      "colGateway": "Gateway",
      "colMatch": "Match",
      "colTxId": "Tx ID",
      "colAmount": "Amount",
      "colLinked": "Linked",
      "yes": "yes",
      "no": "no"
    },
    "discard": "Discard",
    "saving": "Saving…",
    "save": "Save",
    "validation": {
      "nsRequired": "Source namespace is required",
      "nsFormat": "Must start with a letter; only letters, digits, _ and - allowed",
      "nsForbidden": "Generic word \"imap\" is forbidden — pick a more specific namespace",
      "invalidRegex": "Invalid regex on {{gateway}}.{{field}} — please fix before saving"
    },
    "toast": {
      "savedTitle": "IMAP configuration saved",
      "saveFailedTitle": "Could not save IMAP",
      "networkError": "Network error — check connection",
      "testParseFailedTitle": "Test parse failed"
    }
  },
  "chargeback": {
    "list": {
      "heading": "Chargebacks",
      "subtitle": "Monitor merchant chargeback cases — recovery progress and 7-day deadlines.",
      "loading": "Loading…",
      "empty": "No chargeback cases for this filter.",
      "rowAria": "Open chargeback {{id}} for {{merchant}}",
      "colCaseId": "Case ID",
      "colMerchant": "Merchant",
      "colGateway": "Gateway",
      "colAmount": "Amount",
      "colStatus": "Status",
      "colDeadline": "Deadline"
    },
    "filters": {
      "ariaLabel": "Chargeback status filter",
      "all": "All cases",
      "open": "Open",
      "disputed": "Disputed",
      "resolved": "Resolved",
      "debt_outstanding": "Debt outstanding"
    },
    "detail": {
      "back": "Back to Chargebacks",
      "backToList": "Back to list",
      "loading": "Loading case…",
      "notFound": "Case not found.",
      "casePrefix": "Case",
      "subtitle": "{{gateway}} — original charge {{amount}} — opened {{opened}}",
      "recoveryDeadline": "Recovery deadline: {{value}}",
      "caseDetails": "Case Details",
      "gateway": "Gateway",
      "chargebackId": "Chargeback ID",
      "reasonCode": "Reason Code",
      "originalCharge": "Original Charge",
      "merchant": "Merchant",
      "frozenAmount": "Frozen Amount (incl. fee)",
      "recoveryProgress": "Recovery Progress",
      "debtRemaining": "Debt remaining"
    },
    "timeline": {
      "heading": "Timeline",
      "opened": "Chargeback opened",
      "openedDetail": "{{ago}} · funds frozen ({{amount}})",
      "eventDetail": "{{ago}} · {{id}}",
      "approaching": "Recovery deadline approaching",
      "approachingDetail": "in {{time}} · {{debt}} remaining",
      "passed": "Recovery deadline passed",
      "passedDetail": "{{debt}} unrecovered"
    },
    "actions": {
      "heading": "Actions",
      "resolve": "Resolve manually",
      "addNote": "Add admin note",
      "markLost": "Mark as lost (write-off)",
      "note": "Recovery sweeps automatically when the merchant tops up. Manual resolve is admin-tier-only."
    },
    "deadline": {
      "passed": "Deadline passed",
      "remaining": "{{time}} remaining",
      "hoursOnly": "{{hours}}h",
      "daysHours": "{{days}}d {{hours}}h"
    },
    "timeAgo": {
      "dayAgo": "{{count}} day ago",
      "daysAgo": "{{count}} days ago",
      "hourAgo": "{{count}} hr ago",
      "hoursAgo": "{{count}} hrs ago",
      "justNow": "just now"
    },
    "status": {
      "open": "Open",
      "investigating": "Investigating",
      "resolved_won": "Resolved (won)",
      "resolved_lost": "Resolved (lost)",
      "disputed": "Disputed",
      "resolved": "Resolved",
      "debt_outstanding": "Debt outstanding",
      "frozen_pending_recovery": "Frozen — pending recovery"
    },
    "outcome": {
      "won": "won",
      "resolved": "resolved",
      "lost": "lost",
      "expired": "expired"
    },
    "cancel": "Cancel",
    "toast": {
      "loadDetailFailed": "Failed to load chargeback",
      "loadListFailed": "Failed to load chargebacks",
      "networkError": "Network error",
      "checkConnection": "Check connection"
    },
    "resolve": {
      "title": "Resolve chargeback manually",
      "outcomeLabel": "Outcome",
      "outcomeWon": "Won (dispute reversed)",
      "outcomeResolved": "Resolved (recovered)",
      "outcomeLost": "Lost (write-off)",
      "outcomeExpired": "Expired (deadline passed)",
      "terminalHint": "Terminal status — case cannot be reopened from this page.",
      "noteLabel": "Note (optional)",
      "notePlaceholder": "Internal note — context for audit trail (max 500 chars)",
      "submitting": "Resolving…",
      "submit": "Resolve",
      "toast": {
        "failed": "Resolve failed",
        "success": "Chargeback resolved",
        "successDesc": "Marked as {{outcome}}"
      }
    },
    "addNote": {
      "title": "Add admin note",
      "noteLabel": "Note",
      "notePlaceholder": "Internal context — comms, investigation findings, etc. (max 500 chars)",
      "hint": "Notes are append-only and recorded with your admin id.",
      "submitting": "Saving…",
      "submit": "Save note",
      "toast": {
        "requiredTitle": "Note required",
        "requiredDesc": "Please enter a note before saving.",
        "failed": "Add note failed",
        "success": "Note added",
        "successDesc": "Admin note saved to audit trail"
      }
    },
    "markLost": {
      "title": "Mark chargeback as lost?",
      "irreversible": "This is irreversible.",
      "bodyPrefix": "Case",
      "bodySuffix": "will be written off. The outstanding debt will remain on the ledger and this case will no longer auto-recover from merchant top-ups.",
      "submitting": "Marking…",
      "confirm": "Confirm — mark as lost",
      "toast": {
        "failed": "Mark as lost failed",
        "success": "Chargeback marked as lost",
        "successDesc": "{{id}} written off"
      }
    }
  },
  "merchant_picker": {
    "title": "Pick merchant",
    "searchPlaceholder": "Search by name, email, or ID…",
    "loading": "Loading…",
    "noResults": "No matching merchant found",
    "prompt": "Type to search merchant by name / email / ID"
  },
  "errors": {
    "requestFailed": "Request failed (HTTP {{status}})"
  },
  "whitelist": {
    "title": "Whitelist",
    "subtitle": "Per-merchant capabilities that stay closed until an admin opens them.",
    "tab": {
      "merchants": "Merchants",
      "paymentMethods": "Payment methods",
      "config": "Config",
      "log": "Log"
    },
    "merchants": {
      "heading": "Card payment whitelist",
      "hint": "Merchants allowed to pay orders and invoices directly with a saved card, bypassing their wallet. Open it per merchant from Merchant detail → Wallet & Billing.",
      "search": "Search by name or email",
      "colName": "Merchant",
      "colEmail": "Email",
      "colPerOrder": "Per-charge limit",
      "colPerDay": "Daily limit",
      "noLimit": "No limit",
      "empty": "No merchant is whitelisted for card payment yet.",
      "loadError": "Could not load the whitelist.",
      "count": "{{count}} merchant(s)",
      "add": {
        "heading": "Add a merchant",
        "hint": "Opens direct card payment for this merchant. Leave a ceiling empty for no limit.",
        "merchantLabel": "Merchant",
        "perOrderLabel": "Per-charge limit ($)",
        "perDayLabel": "Daily limit ($)",
        "submit": "Add to whitelist",
        "submitting": "Adding…",
        "pickMerchant": "Pick a merchant first.",
        "badAmount": "Enter a valid amount, or leave the box empty for no limit.",
        "alreadyListed": "This merchant is already whitelisted.",
        "failed": "Could not add this merchant.",
        "added": "Merchant added to the whitelist.",
        "noLimitConfirm": "I mean no limit for the empty ceiling(s)",
        "noLimitRequired": "An empty ceiling means unlimited card spend — tick the box to confirm, or enter an amount."
      },
      "picker": {
        "title": "Pick merchant",
        "searchPlaceholder": "Search by name, email, or ID…",
        "loading": "Loading…",
        "noResults": "No matching merchant found",
        "prompt": "Type to search by name, email, or ID"
      },
      "colActions": "Actions",
      "remove": {
        "cta": "Remove",
        "confirmTitle": "Remove from whitelist?",
        "confirmBody": "{{name}} loses the card payment option immediately, on every payment screen. The limits you set are kept, so turning it back on later does not start from no limit.",
        "confirmCta": "Remove",
        "done": "Merchant removed from the whitelist.",
        "failed": "Could not remove this merchant."
      },
      "removing": "Removing…",
      "noPermission": "You do not have permission to change the whitelist."
    },
    "paymentMethods": {
      "heading": "Methods open to whitelisted merchants",
      "hint": "Only Stripe cards can be charged directly today. PayPal has no vaulting flow, so it cannot be used for direct payment.",
      "stripe": "Stripe (saved cards)",
      "stripeOn": "Available",
      "stripeOff": "Gateway disabled — enable it in Gateway Settings first",
      "stripeUnknown": "Could not read the gateway status — this is not a confirmation that Stripe is off.",
      "paypal": "PayPal",
      "paypalUnsupported": "Not supported — no saved-account flow"
    },
    "config": {
      "heading": "Rules that admins cannot override",
      "invoiceRule": "Invoice-billed merchants can pay an invoice by card, but never an individual order — that order would be billed again on their next invoice.",
      "refundRule": "A card charge cannot be refunded back to the card from here. Refunds go to the merchant's wallet.",
      "threeDsRule": "Cards that require 3-D Secure are declined — there is no on-session authentication step in this flow.",
      "limitsHint": "Per-charge and daily limits are set per merchant. Leaving one empty means no limit.",
      "fraudLink": "Fraud settings"
    },
    "noAccess": "You do not have permission to view the whitelist.",
    "log": {
      "heading": "Who changed what",
      "hint": "Every time an admin opens, closes, or re-limits card payment for a merchant.",
      "colTime": "Time",
      "colAdmin": "Admin",
      "colMerchant": "Merchant",
      "colChange": "Change",
      "colLimits": "Limits after",
      "change": {
        "added": "Added",
        "removed": "Removed",
        "limits": "Limits changed"
      },
      "filter": {
        "from": "From",
        "to": "To"
      },
      "empty": "No whitelist changes recorded yet.",
      "loadError": "Could not load the log.",
      "loadMore": "Load more",
      "unknownAdmin": "—",
      "noLimit": "No limit",
      "legacyNote": "Entries recorded before this log existed may not name the admin."
    }
  }
}
